var es = Object.defineProperty;
var ts = (e, t, n) => t in e ? es(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var tt = (e, t, n) => (ts(e, typeof t != "symbol" ? t + "" : t, n), n);
import { isPlainObject as ns, trim as _, isString as de, cloneDeep as rs, forEach as os, isObject as ss, get as C, isArray as Tn, mean as is, isNumber as je, reduce as pt, camelCase as J, has as as, isFinite as An, isBoolean as sr, isEmpty as mt, omit as ir, isNil as cs, find as ls } from "lodash";
import { encodeXML as ar } from "entities";
import { XmlNode as In, parseXml as Es } from "@rgrove/parse-xml";
import { v4 as cr } from "uuid";
import Tt from "twig";
import { jsx as A, jsxs as Z, Fragment as ds } from "react/jsx-runtime";
import us, { Fragment as Rn, forwardRef as lr, useRef as Ie, useState as xe, useEffect as st } from "react";
import f, { css as Ts, createGlobalStyle as As, StyleSheetManager as Is } from "styled-components";
import ht from "react-dotdotdot";
import Rs from "dayjs";
import { animated as vt, useSpring as Nn, useIsomorphicLayoutEffect as Ns } from "@react-spring/web";
import _s from "linkify-it";
import Ls from "tlds";
import Os from "react-shadow";
const Ss = [
  "title"
  /* TITLE */
];
var gt = /* @__PURE__ */ ((e) => (e.HOST_DEFAULT_STYLES = "defaultStyles", e.EMIT_GLOBAL_STYLES = "emitGlobalStyles", e))(gt || {}), it = /* @__PURE__ */ ((e) => (e.BACKGROUND_COLOR = "background", e.PADDING = "padding", e))(it || {});
function _n(e) {
  return ns(e);
}
function Er(e) {
  return de(e);
}
function q(e) {
  const t = {};
  for (const n in e) {
    const r = e[n];
    if (Er(r)) {
      const s = _(r);
      s && (t[n] = s);
    } else
      r && (t[n] = r);
  }
  return t;
}
function Fn() {
  let e = () => {
  }, t = () => {
  };
  return {
    promise: new Promise((r, s) => {
      e = r, t = s;
    }),
    resolve: e,
    reject: t
  };
}
function dr(e) {
  const t = rs(e);
  let n = {
    __data: t,
    __root: t
  };
  return _n(t) && (n = { ...t, ...n }), Object.freeze(n);
}
function De(e) {
  return e.type === In.TYPE_ELEMENT;
}
function Mt(e) {
  return e.type === In.TYPE_TEXT;
}
function Ln(e) {
  return Mt(e) && !_(e.text);
}
function Ds(e) {
  return e.type === In.TYPE_PROCESSING_INSTRUCTION;
}
function at(e, t) {
  if (e != null && e.length)
    return e.find((n) => De(n) && n.name === t);
}
function ur(e, t = "id") {
  if (!De(e))
    return;
  const n = t.trim();
  if (!n)
    throw Error('Missing or invalid "idAttributeName" parameter');
  e.attributes[n] = cr(), !e.isEmpty && os(e.children, (r) => {
    De(r) && ur(r, n);
  });
}
function fs(e, t) {
  const n = `z_${Math.floor(Math.random() * 1e8)}`, r = new RegExp(` ${t}[\\s]*=[\\s]*("([^"]+)"|'([^']+)')`, "g");
  return e.replace(r, (i, a, l) => {
    if (/<(\/?[A-Za-z]+)>/.test(a) || /\/>/.test(a))
      return i;
    const c = l || a.substring(1, a.length - 1), E = ar(_(c));
    return ` ${n}="${E}"`;
  }).replace(new RegExp(n, "g"), () => t);
}
function Cs(e) {
  return e ? e.replace(/&(?=\s+|[^a-zA-Z#]+|$)/g, () => "&amp;") : "";
}
function ps(e) {
}
function ms() {
  Tt.extend(ps);
}
function hs(e, t) {
  const n = Number(e);
  if (Number.isNaN(n))
    return String(e);
  const r = gs(t);
  try {
    return Intl.NumberFormat(r.locale, {
      style: "currency",
      currency: r.currencyCode,
      currencySign: r.negativeValueStyle,
      minimumFractionDigits: r.decimalPlaces,
      maximumFractionDigits: r.decimalPlaces
    }).format(n);
  } catch {
    return String(e);
  }
}
function gs(e) {
  const t = {
    currencyCode: "USD",
    decimalPlaces: 2,
    locale: navigator.language,
    negativeValueStyle: "standard"
  };
  if (!e || !e.length)
    return t;
  const [n] = e;
  if (!ss(n))
    return t;
  const r = _(String(C(n, "currencyCode", t.currencyCode)));
  t.currencyCode = r || t.currencyCode;
  const s = Number(C(n, "decimalPlaces", t.decimalPlaces));
  t.decimalPlaces = Number.isNaN(s) ? t.decimalPlaces : Math.max(0, s), t.locale = _(String(C(n, "locale", t.locale)));
  const i = _(String(C(n, "negativeValueStyle", t.negativeValueStyle)));
  return t.negativeValueStyle = i === "standard" || i === "accounting" ? i : t.negativeValueStyle, t;
}
const Vn = {
  format_currency: hs
};
function ys() {
  for (const e in Vn)
    Tt.extendFilter(e, Vn[e]);
}
function $s(...e) {
  const t = [];
  for (const n of e)
    Tn(n) ? t.push(...n.map(Wn)) : t.push(Wn(n));
  return String(is(t));
}
function Wn(e) {
  return de(e) ? Number(e) : je(e) ? e : NaN;
}
const Xn = {
  average: $s
};
function bs() {
  for (const e in Xn)
    Tt.extendFunction(e, Xn[e]);
}
var se = /* @__PURE__ */ ((e) => (e.TAG = "logic", e.TAG_TYPE_PREFIX = "Twig.logic.type.", e.EXPRESSION_TYPE_PREFIX = "Twig.expression.type.", e.INTERPOLATION_BLOCK = "output", e.INTERPOLATION_BLOCK_PRE = "output_whitespace_pre", e.INTERPOLATION_BLOCK_POST = "output_whitespace_post", e.INTERPOLATION_BLOCK_BOTH = "output_whitespace_both", e.FILTER = "Twig.expression.type.filter", e.FUNCTION = "Twig.expression.type._function", e.RAW_TEXT = "raw", e.TEST = "Twig.expression.type.test", e.VARIABLE = "Twig.expression.type.variable", e))(se || {}), Te = /* @__PURE__ */ ((e) => (e.FILTER = "filter", e.FUNCTION = "func", e.TAG = "tag", e.TEST = "test", e.VARIABLE = "var", e))(Te || {});
const Ps = {
  [Te.FILTER]: [
    "abs",
    "capitalize",
    "date",
    "date_modify",
    "first",
    "format_currency",
    "join",
    "last",
    "length",
    "lower",
    "replace",
    "round",
    "title",
    "upper"
  ],
  [Te.FUNCTION]: ["average", "date", "max", "min", "random"],
  [Te.TAG]: ["if", "else", "elseif"],
  [Te.TEST]: ["defined", "empty", "even", "null", "odd"]
}, vs = (e, t) => {
  const n = _(t);
  return e === Te.VARIABLE ? !!n : (Ps[e] || []).includes(n);
};
function Ms(e) {
  return e.type === se.RAW_TEXT;
}
function Tr(e) {
  return e.type === se.INTERPOLATION_BLOCK || e.type === se.INTERPOLATION_BLOCK_PRE || e.type === se.INTERPOLATION_BLOCK_POST || e.type === se.INTERPOLATION_BLOCK_BOTH;
}
function Ar(e) {
  return e.type === se.TAG;
}
function Us(e) {
  return (e.type || "").startsWith(se.EXPRESSION_TYPE_PREFIX);
}
function xs(e) {
  return e.type === se.FILTER;
}
function Gs(e) {
  return e.type === se.FUNCTION;
}
function ws(e) {
  return e.type === se.TEST;
}
function Bs(e) {
  return (e.token.type || "").substring(se.TAG_TYPE_PREFIX.length);
}
function Fs(e) {
  return e.value;
}
function Vs(e) {
  return e.fn;
}
function Ws(e) {
  return e.filter;
}
function he(e, t) {
  var n;
  if (e != null && e.length) {
    for (const r of e)
      if (Tr(r))
        he(r.stack, t);
      else if (Ar(r)) {
        const s = Bs(r);
        if (!t(Te.TAG, s))
          throw Error(`Tag "${s}" is not available`);
        he(r.token.stack, t), he(r.token.output, t);
      } else if (Us(r))
        if (Gs(r)) {
          const s = Vs(r);
          if (!t(Te.FUNCTION, s))
            throw Error(`Function "${s}" is not available`);
          he(r.params, t);
        } else if (xs(r)) {
          const s = Fs(r);
          if (!t(Te.FILTER, s))
            throw Error(`Filter "${s}" is not available`);
          he(r.params, t);
        } else if (ws(r)) {
          const s = Ws(r);
          if (!t(Te.TEST, s))
            throw Error(`Test "${s}" is not available`);
          he(r.params, t);
        } else
          (n = r.params) != null && n.length && he(r.params, t);
  }
}
function Ir(e, t) {
  const n = Tt.twig({
    data: e,
    // @ts-expect-error The published types do not match the actual parameters
    autoescape: !!(t != null && t.forceHtmlEscape),
    strict_variables: !!(t != null && t.strictVariables),
    rethrow: !0
  });
  return he(n.tokens, vs), n;
}
const Yn = cr();
function Xs(e, t) {
  const n = `{% if (${e}) %}${Yn}{% endif %}`;
  return (Ir(n, { strictVariables: !1, forceHtmlEscape: !1 }).render(t) || "").trim() === Yn;
}
function Ys(e, t, n) {
  return Ir(e, { strictVariables: !1, forceHtmlEscape: n == null ? void 0 : n.htmlEscape }).render(t);
}
ms();
ys();
bs();
class Hs {
  constructor(t) {
    tt(this, "buffer", "");
    tt(this, "offset", 0);
    this.buffer = t;
  }
  /**
   * Replaces a fragment in the string where the from/to positions are relative to the ORIGINAL string.
   * This is helpful when we have a list of parsed nodes that we need to replace without having to
   * reparse after each replacement
   *
   * @param from - fragment start relative to the original string
   * @param to - fragment end relative to the original string
   */
  escapeFragment(t, n) {
    if (t < 0 || n < 0 || t > n)
      throw Error("Invalid parameters");
    const r = this.buffer.substring(t + this.offset, n + this.offset), s = ar(r), i = s.length - r.length;
    this.buffer = this.buffer.substring(0, t + this.offset) + s + this.buffer.substring(n + this.offset), this.offset = this.offset + i;
  }
  get escapedString() {
    return this.buffer;
  }
}
function ks(e) {
  const t = _(e);
  if (!t)
    return t;
  const n = Tt.twig({ data: t, rethrow: !0 }), r = new Hs(t);
  return n.tokens.forEach((s) => Rr(s, r, !1)), r.escapedString;
}
function Rr(e, t, n) {
  var r;
  Ms(e) ? n && t.escapeFragment(e.position.start, e.position.end) : Tr(e) ? t.escapeFragment(e.position.start, e.position.end) : Ar(e) && (t.escapeFragment(e.position.open.start, e.position.open.end), (r = e.token.output) != null && r.length && e.token.output.forEach((s) => Rr(s, t, !0)));
}
function Nr() {
  return {
    evaluateCondition: Xs,
    interpolateString: Ys
  };
}
var I = /* @__PURE__ */ ((e) => (e.BLOCK = "Block", e.BOOLEAN_VALUE = "BooleanValue", e.CARD = "Card", e.COLUMN = "Column", e.COLUMN_GROUP = "ColumnGroup", e.CURRENCY_VALUE = "CurrencyValue", e.DATETIME_VALUE = "DateTimeValue", e.DIVIDER = "Divider", e.DRAWER = "Drawer", e.DRAWER_FIXED_PART = "Fixed", e.DRAWER_EXPANDABLE_PART = "Expandable", e.FORMULA = "Formula", e.IMAGE = "Image", e.LINK = "Link", e.LIST = "List", e.NUMERIC_VALUE = "NumericValue", e.SECTION = "Section", e.SPACER = "Spacer", e.STRING_VALUE = "StringValue", e.TEXT = "Text", e))(I || {}), re = /* @__PURE__ */ ((e) => (e.NONE = "none", e.X_SMALL = "extraSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(re || {}), L = /* @__PURE__ */ ((e) => (e.GREY_100 = "grey100", e.GREY_200 = "grey200", e.GREY_300 = "grey300", e.GREY_500 = "grey500", e.GREY_800 = "grey800", e.GREY_900 = "grey900", e.BLUEGREY_100 = "blueGrey100", e.BLUEGREY_300 = "blueGrey300", e.BLUEGREY_500 = "blueGrey500", e.BLUEGREY_800 = "blueGrey800", e.GREEN_100 = "green100", e.GREEN_400 = "green400", e.GREEN_700 = "green700", e.PURPLE_100 = "purple100", e.PURPLE_400 = "purple400", e.PURPLE_700 = "purple700", e.YELLOW_100 = "yellow100", e.YELLOW_400 = "yellow400", e.YELLOW_700 = "yellow700", e.RED_100 = "red100", e.RED_400 = "red400", e.RED_700 = "red700", e.BLACK = "black", e.WHITE = "white", e.GREY = "grey", e.GREEN = "green", e.RED = "red", e.PURPLE = "purple", e.YELLOW = "yellow", e.TRANSPARENT = "transparent", e.INHERIT = "inherit", e))(L || {}), v = /* @__PURE__ */ ((e) => (e.DEFAULT_TEXT = "text", e.SUBTLE_TEXT = "subtleText", e.PRIMARY = "primary", e.INFO = "info", e.WARNING = "warning", e.ERROR = "error", e.BACKGROUND = "background", e.BORDER = "border", e.BORDER_DARK = "borderDark", e.BORDER_LIGHT = "borderLight", e))(v || {}), G = /* @__PURE__ */ ((e) => (e.NONE = "none", e.X_SMALL = "extraSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(G || {}), oe = /* @__PURE__ */ ((e) => (e.NONE = "none", e.THIN = "thin", e.MEDIUM = "medium", e.THICK = "thick", e.X_THICK = "extraThick", e))(oe || {}), le = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.DEFAULT = "default", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(le || {}), Ee = /* @__PURE__ */ ((e) => (e.LIGHT = "light", e.REGULAR = "regular", e.MEDIUM = "medium", e.SEMI_BOLD = "semiBold", e.BOLD = "bold", e))(Ee || {}), ie = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.CENTER = "center", e))(ie || {}), Re = /* @__PURE__ */ ((e) => (e.NONE = "none", e.NORMAL = "normal", e.UNDERLINED = "underlined", e))(Re || {}), ae = /* @__PURE__ */ ((e) => (e.AUTO = "auto", e.LTR = "ltr", e.RTL = "rtl", e))(ae || {}), yt = /* @__PURE__ */ ((e) => (e.NORMAL = "normal", e.BREAK_WORDS = "breakWords", e))(yt || {}), _e = /* @__PURE__ */ ((e) => (e.AUTO = "auto", e.X_SMALL = "extraSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(_e || {}), nt = /* @__PURE__ */ ((e) => (e.ROUND = "circle", e.RECT = "rectangle", e))(nt || {}), rt = /* @__PURE__ */ ((e) => (e.FILL = "fill", e.FIT = "fit", e))(rt || {}), Le = /* @__PURE__ */ ((e) => (e.BOTTOM = "bottom", e.CENTER = "center", e.LEFT = "left", e.MIDDLE = "middle", e.RIGHT = "right", e.TOP = "top", e))(Le || {}), $t = /* @__PURE__ */ ((e) => (e.NONE = "none", e.REGULAR = "regular", e))($t || {}), Ae = /* @__PURE__ */ ((e) => (e.EXPANDABLE = "expandable", e.SCROLLABLE = "scrollable", e.STATIC = "static", e))(Ae || {});
const On = 10, Hn = 25;
var Sn = /* @__PURE__ */ ((e) => (e.AUTO = "auto", e.FULL = "100%", e))(Sn || {}), He = /* @__PURE__ */ ((e) => (e.AUTO = "auto", e.STRETCH = "stretch", e))(He || {}), g = /* @__PURE__ */ ((e) => (e.ROW = "row", e.STACKED = "stacked", e))(g || {}), Me = /* @__PURE__ */ ((e) => (e.COLLAPSED = "collapsed", e.EXPANDED = "expanded", e.EXPAND_FIRST = "expandFirst", e))(Me || {}), ot = /* @__PURE__ */ ((e) => (e.ACCOUNTING = "accounting", e.STANDARD = "standard", e))(ot || {}), X = /* @__PURE__ */ ((e) => (e.NONE = "none", e.SECTION_STYLES = "styles", e.SECTION_DEFAULTS = "defaults", e.SECTION_GLOBAL_STYLES = "globalStyles", e.STYLE_ALIGNMENT = "alignment", e.STYLE_BORDER_RADIUS = "borderRadius", e.STYLE_COLOR = "colorAliases", e.STYLE_ELEVATION = "elevation", e.STYLE_FONT_SIZE = "fontSize", e.STYLE_FONT_WEIGHT = "fontWeight", e.STYLE_SPACING = "spacing", e.STYLE_SIZE = "size", e.STYLE_STROKE_WIDTH = "strokeWidth", e.STYLE_TEXT_WRAPPING = "wrap", e))(X || {}), u = /* @__PURE__ */ ((e) => (e.ALIGNMENT = "align", e.BORDER_RADIUS = "border radius", e.COLOR = "color", e.ELEVATION = "box shadow", e.FLEX_ALIGNMENT = "flex align", e.FONT_SIZE = "font size", e.FONT_WEIGHT = "font weight", e.IMAGE_SIZE = "image size", e.SPACING = "spacing", e.STROKE_WIDTH = "stroke width", e.TEXT_DECORATION = "decoration", e.TEXT_WRAPPING = "wrapping", e))(u || {});
const Ks = {
  // Misc
  bull: "•",
  copy: "©",
  hellip: "…",
  reg: "®",
  trade: "™",
  // Arrows
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔"
};
function zs(e) {
  return Ks[e];
}
function Jt(e) {
  return Es(e, {
    preserveComments: !1,
    preserveXmlDeclaration: !0,
    resolveUndefinedEntity: (n) => {
      const r = /^&([a-z]+);$/.exec(n), s = r && r[1];
      if (s)
        return zs(s);
    }
  });
}
var o = /* @__PURE__ */ ((e) => (e.ARIA_DESCRIPTION = "aria", e.CLASS_NAME = "className", e.CONDITIONAL_RENDERING_EXPRESSION = "when", e.DATA_SOURCE = "dataSource", e.ELEMENT_ID = "id", e.INTERNAL_COMPONENT_ID = "component_id", e.TEST_ID = "testId", e.TEXT_DIRECTION = "direction", e))(o || {});
function Qt(e) {
  const t = fs(e, o.CONDITIONAL_RENDERING_EXPRESSION), n = ks(t);
  return Cs(n);
}
class ml {
  constructor(t) {
    this.options = t;
  }
  /**
   * Extracts the root Card component attributes, interpolates the attributes that require data, then returns
   * the results.
   *
   * We need this helper in order to support the environments that already have an existing "card" implementation (i.e.
   * Agent Desktop) and need to have access to the `Card` parameters without having to render the Card itself
   */
  extractCardParameters(t, n) {
    var d;
    const r = _(t);
    if (!r)
      throw Error("Invalid or missing template");
    const i = !!((d = this.options) != null && d.preprocessTemplate) ? Qt(r) : r, l = Jt(i).root;
    if (l.name !== I.CARD)
      throw Error(`Expected template root element "${I.CARD}", found "${l.name}" instead`);
    const c = Nr(), E = dr(n);
    return pt(
      l.attributes,
      (N, S, O) => {
        const D = Ss.includes(O) ? c.interpolateString(S, E) : S;
        return N[O] = _(D), N;
      },
      {}
    );
  }
  /**
   * Extracts top-level template processing instructions, if any
   */
  extractTemplateMeta(t) {
    var a;
    const n = _(t);
    if (!n)
      throw Error("Invalid or missing template");
    const s = !!((a = this.options) != null && a.preprocessTemplate) ? Qt(n) : n;
    return Jt(s).children.reduce(
      (l, c) => (Ds(c) && (l[c.name] = _(c.content)), l),
      {}
    );
  }
}
const P = f.div`
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
`;
var te = /* @__PURE__ */ ((e) => (e.ALIGNMENT = "alignment", e.BACKGROUND = "background", e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e.PADDING = "padding", e))(te || {}), Dn = /* @__PURE__ */ ((e) => (e.BORDER = "border", e))(Dn || {}), Ut = /* @__PURE__ */ ((e) => (e.BORDER_WIDTH = "borderWidth", e))(Ut || {});
class M {
  constructor(t) {
    tt(this, "_map");
    this._map = { ...t };
  }
  overrideStyles(t) {
    this._map = { ...this._map, ...t };
  }
  get styles() {
    return { ...this._map };
  }
  get styleAttributeNames() {
    return Object.keys(this._map);
  }
  get styleValues() {
    return pt(
      this._map,
      (t, n, r) => (t[r] = n.style, t),
      {}
    );
  }
  get styleTypes() {
    return pt(
      this._map,
      (t, n, r) => (t[r] = n.styleType, t),
      {}
    );
  }
}
const en = new M({
  [te.ALIGNMENT]: { style: ie.LEFT, styleType: u.ALIGNMENT },
  [te.BACKGROUND]: { style: L.TRANSPARENT, styleType: u.COLOR },
  [te.BORDER_RADIUS]: { style: re.SMALL, styleType: u.BORDER_RADIUS },
  [te.BORDER_COLOR]: { style: v.BORDER, styleType: u.COLOR },
  [te.PADDING]: { style: G.NONE, styleType: u.SPACING }
}), Ot = new M({
  [Ut.BORDER_WIDTH]: { style: oe.THIN, styleType: u.STROKE_WIDTH }
});
function Ge(e, t, n = !1) {
  const r = _(C(e, t)).toLowerCase();
  if (!r)
    return n;
  switch (r) {
    case "yes":
    case "true":
      return !0;
    case "no":
    case "false":
      return !1;
    default:
      throw Error(
        `Unexpected attribute value for "${t}". Expected "yes"/"no" or "true"/"false", got "${r}" instead`
      );
  }
}
function R(e, t, n = "") {
  return _(C(e, t, n));
}
function b(e, t) {
  return t.reduce(
    (n, r) => (n[r] = R(e, String(r)), n),
    {}
  );
}
function At(e, t, n = 0) {
  const r = _(C(e, t) || String(n)), s = parseInt(r, 10);
  if (s !== s)
    throw Error(`Unexpected "${t}" value. Expected a numeric string, got "${r}" instead`);
  return s;
}
function Q(e, t, n, r) {
  const s = C(e, t) || r, i = J(s);
  if (n.includes(i))
    return i;
  throw Error(
    `Unexpected attribute value for "${t}". Expected one of ${JSON.stringify(n)}, got "${s}" instead`
  );
}
function _r(e, t) {
  return Q(
    e,
    t,
    [ie.LEFT, ie.RIGHT, ie.CENTER],
    ie.LEFT
  );
}
function pe(e, t) {
  return Q(
    e,
    t,
    [ae.AUTO, ae.RTL, ae.LTR],
    ae.AUTO
  );
}
function Zs(e, t, n) {
  for (const r of t)
    if (!_(C(e, r)))
      throw Error(`<${n}> is missing a required parameter "${r}"`);
}
function k(e, t, n) {
  return e.reduce((r, s) => (r[s] = R(t, s, n[s]), r), {});
}
function W(e, t = [], n = !0) {
  return pt(
    e,
    (r, s, i) => {
      if (t.includes(i))
        r[i] = s;
      else {
        const c = s && (/^[1-9][0-9]*(?:px|pt|em|rem)/gi.test(s) || s.includes("/")) ? s.toLowerCase() : J(s);
        (c || !n) && (r[i] = c);
      }
      return r;
    },
    {}
  );
}
var x = /* @__PURE__ */ ((e) => (e.DATA_VALUE = "data", e.ITERATOR = "iterator", e.CONTAINER = "container", e.DECORATIVE_NODE = "decoration", e))(x || {});
function me({
  parentNodeName: e,
  nodes: t,
  dataContext: n,
  getNodeDescriptor: r,
  expressionEvaluator: s
}) {
  return t != null && t.length ? !!t.find((i) => {
    var c;
    if (!De(i))
      return !1;
    const a = r(i.name), l = a.canRender({
      attributes: i.attributes,
      children: i.children,
      parentNodeName: e,
      dataContext: n,
      getNodeDescriptor: r,
      expressionEvaluator: s
    });
    return a.nodeType === x.DATA_VALUE || a.nodeType === x.ITERATOR ? l : a.nodeType === x.CONTAINER && ((c = i.children) != null && c.length) ? l && me({
      parentNodeName: i.name,
      nodes: i.children,
      dataContext: n,
      getNodeDescriptor: r,
      expressionEvaluator: s
    }) : !1;
  }) : !1;
}
function ye({
  parentNodeName: e,
  nodes: t,
  dataContext: n,
  hostAppConfig: r,
  getInputRegistry: s,
  getNodeDescriptor: i,
  expressionEvaluator: a,
  actionCallbacks: l
}) {
  return t != null && t.length ? t.reduce((E, d) => {
    if (!De(d)) {
      if (Ln(d))
        return E;
      throw Error("Unexpected child. All plain text must be wrapped in <Text></Text>");
    }
    const N = i(d.name);
    if (!N.canRender({
      attributes: d.attributes,
      children: d.children,
      parentNodeName: e,
      dataContext: n,
      getNodeDescriptor: i,
      expressionEvaluator: a
    }))
      return E;
    const O = N.render({
      attributes: d.attributes,
      children: d.children,
      parentNodeName: e,
      dataContext: n,
      hostAppConfig: r,
      getInputRegistry: s,
      getNodeDescriptor: i,
      expressionEvaluator: a,
      actionCallbacks: l
    });
    return Tn(O) ? E = E.concat(O) : O && E.push(O), E;
  }, []).map((E, d) => /* @__PURE__ */ A(Rn, { children: E }, d)) : [];
}
const js = {
  [L.GREY_100]: "#F6F6F6",
  [L.GREY_200]: "#EEEEEE",
  [L.GREY_300]: "#E3E3E3",
  [L.GREY_500]: "#B3B3B3",
  [L.GREY_800]: "#484848",
  [L.GREY_900]: "#212121",
  [L.BLUEGREY_100]: "#CFD8DC",
  [L.BLUEGREY_300]: "#90A4AE",
  [L.BLUEGREY_500]: "#607D8B",
  [L.BLUEGREY_800]: "#37474F",
  [L.GREEN_100]: "#D8F4D8",
  [L.GREEN_400]: "#009B00",
  [L.GREEN_700]: "#003C00",
  [L.PURPLE_100]: "#E6DCFF",
  [L.PURPLE_400]: "#8C69F0",
  [L.PURPLE_700]: "#331962",
  [L.YELLOW_100]: "#FFF2C6",
  [L.YELLOW_400]: "#FFBE00",
  [L.YELLOW_700]: "#8E660C",
  [L.RED_100]: "#FFCDD2",
  [L.RED_400]: "#D50E0E",
  [L.RED_700]: "#5C0000",
  [L.BLACK]: "#000000",
  [L.WHITE]: "#FFFFFF",
  [L.GREEN]: "#009B00",
  [L.GREY]: "#B3B3B3",
  [L.PURPLE]: "#8C69F0",
  [L.RED]: "#D50E0E",
  [L.YELLOW]: "#FFBE00",
  [L.TRANSPARENT]: "transparent",
  [L.INHERIT]: "inherit"
}, qs = {
  [v.BACKGROUND]: L.WHITE,
  [v.BORDER]: L.GREY_300,
  [v.BORDER_DARK]: L.GREY_500,
  [v.BORDER_LIGHT]: L.GREY_200,
  [v.DEFAULT_TEXT]: L.GREY_900,
  [v.ERROR]: L.RED_400,
  [v.INFO]: L.PURPLE_400,
  [v.PRIMARY]: L.GREEN_400,
  [v.SUBTLE_TEXT]: L.GREY_500,
  [v.WARNING]: L.YELLOW_400
};
function Lr(e) {
  if (!e)
    throw Error("Missing color value");
  const t = J(e), n = C(qs, t, t), r = C(js, n);
  if (!r)
    throw Error(`Unexpected color "${e}"`);
  return r;
}
const kn = {
  [$t.NONE]: "none",
  [$t.REGULAR]: "0 2px 8px 0 rgba(0,0,0,0.08)"
};
function Js(e) {
  const t = J(e);
  if (!t)
    return kn[$t.NONE];
  const n = C(kn, t);
  if (!n)
    throw Error(`Unexpected elevation "${e}"`);
  return n;
}
function Ze(e, t = []) {
  const n = _(e).toLowerCase();
  return /^([1-9]\d*)(px|em|rem|pt)$/gi.test(n) || t.includes(n);
}
function Or(e) {
  const t = _(e);
  return /^((100)|([1-9]\d?))%$/g.test(t);
}
function Ke(e) {
  const [t, n] = _(e).split("/").map((r) => _(r).toLowerCase());
  return [t || "16px", n || "normal"];
}
function Qs(e) {
  const t = _(e).split("/").map((s) => _(s).toLowerCase()), [n, r] = t;
  if (!Ze(n, ["auto"]) || r && !Ze(r, ["auto"]) || t.length > 2)
    throw Error(`Invalid image size "${e}"`);
  return [n, r || "auto"];
}
const ei = {
  [_e.AUTO]: "auto",
  [_e.X_SMALL]: "16px/16px",
  [_e.SMALL]: "24px/24px",
  [_e.MEDIUM]: "32px/32px",
  [_e.LARGE]: "84px/84px",
  [_e.X_LARGE]: "124px/124px"
};
function ti(e) {
  const t = J(e);
  if (!t)
    throw Error("Missing or invalid size");
  const n = C(ei, t);
  if (!n) {
    const r = _(e).toLowerCase();
    if (ni(r))
      return ri(r);
    throw Error(`Invalid size value "${e}"`);
  }
  return n;
}
function ni(e) {
  const t = e.split("/").map((r) => _(r));
  return t.length < 1 || t.length > 2 ? !1 : t.find((r) => !Ze(r)) === void 0;
}
function ri(e) {
  const t = e.split("/").map((n) => _(n));
  return t.length === 1 ? `${t[0]}/${t[0]}` : `${t[0]}/${t[1]}`;
}
const Kn = {
  [re.NONE]: "0",
  [re.X_SMALL]: "2px",
  [re.SMALL]: "4px",
  [re.MEDIUM]: "8px",
  [re.LARGE]: "16px",
  [re.X_LARGE]: "20px"
}, zn = {
  [G.NONE]: "0",
  [G.X_SMALL]: "2px",
  [G.SMALL]: "4px",
  [G.MEDIUM]: "8px",
  [G.LARGE]: "16px",
  [G.X_LARGE]: "24px"
}, Zn = {
  [oe.NONE]: "0",
  [oe.THIN]: "1px",
  [oe.MEDIUM]: "2px",
  [oe.THICK]: "3px",
  [oe.X_THICK]: "4px"
};
function oi(e) {
  const t = J(e);
  if (!t)
    return zn[G.NONE];
  const n = C(zn, t);
  if (!n)
    throw Error(`Unexpected spacing value "${e}"`);
  return n;
}
function si(e) {
  const t = J(e);
  if (!t)
    return Kn[re.NONE];
  const n = C(Kn, t);
  if (!n)
    throw Error(`Unexpected radius value "${e}"`);
  return n;
}
function ii(e) {
  const t = J(e);
  if (!t)
    return Zn[oe.NONE];
  const n = C(Zn, t);
  if (!n) {
    const r = _(e).toLowerCase();
    if (Ze(r, ["0", "0px"]))
      return r;
    throw Error(`Invalid width "${e}"`);
  }
  return n;
}
const ai = {
  [ie.CENTER]: "center",
  [ie.LEFT]: "left",
  [ie.RIGHT]: "right"
}, ci = {
  [yt.NORMAL]: "normal",
  [yt.BREAK_WORDS]: "break-word"
}, li = {
  [Re.NONE]: "none",
  [Re.NORMAL]: "initial",
  [Re.UNDERLINED]: "underline"
};
function Ei(e) {
  const t = C(ai, J(e));
  if (!t)
    throw Error(`Unexpected alignment "${e}"`);
  return t;
}
function di(e) {
  const t = C(li, J(e));
  if (!t)
    throw Error(`Unexpected text decoration "${e}"`);
  return t;
}
function ui(e) {
  const t = C(ci, J(e));
  if (!t)
    throw Error(`Unexpected wrapping mode "${e}"`);
  return t;
}
const Ti = {
  [Le.TOP]: "flex-start",
  [Le.LEFT]: "flex-start",
  [Le.CENTER]: "center",
  [Le.MIDDLE]: "center",
  [Le.BOTTOM]: "flex-end",
  [Le.RIGHT]: "flex-end"
};
function Ai(e) {
  const t = C(Ti, J(e));
  if (!t)
    throw Error(`Unexpected alignment "${e}"`);
  return t;
}
const Ii = {
  [le.SMALL]: "10px/16px",
  [le.DEFAULT]: "13px/20px",
  [le.MEDIUM]: "16px/24px",
  [le.LARGE]: "20px/28px",
  [le.X_LARGE]: "24px/32px"
}, Ri = {
  [Ee.LIGHT]: "300",
  [Ee.REGULAR]: "400",
  [Ee.MEDIUM]: "500",
  [Ee.SEMI_BOLD]: "600",
  [Ee.BOLD]: "700"
};
function Ni(e) {
  const t = C(Ii, J(e));
  if (!t)
    throw Error(`Unexpected font size "${e}"`);
  return t;
}
function _i(e) {
  const t = C(Ri, J(e));
  if (!t)
    throw Error(`Unexpected font weight "${e}"`);
  return t;
}
function Li(e, t, n) {
  const s = {
    [u.ALIGNMENT]: X.STYLE_ALIGNMENT,
    [u.BORDER_RADIUS]: X.STYLE_BORDER_RADIUS,
    [u.COLOR]: X.STYLE_COLOR,
    [u.ELEVATION]: X.STYLE_ELEVATION,
    [u.FLEX_ALIGNMENT]: X.STYLE_ALIGNMENT,
    [u.FONT_SIZE]: X.STYLE_FONT_SIZE,
    [u.FONT_WEIGHT]: X.STYLE_FONT_WEIGHT,
    [u.IMAGE_SIZE]: X.STYLE_SIZE,
    [u.SPACING]: X.STYLE_SPACING,
    [u.STROKE_WIDTH]: X.STYLE_STROKE_WIDTH,
    [u.TEXT_DECORATION]: X.NONE,
    [u.TEXT_WRAPPING]: X.STYLE_TEXT_WRAPPING
  }[t];
  if (s !== X.NONE)
    return C(n, [X.SECTION_STYLES, s, e]);
}
function Oi(e, t) {
  return {
    [u.ALIGNMENT]: Ei,
    [u.BORDER_RADIUS]: si,
    [u.COLOR]: Lr,
    [u.ELEVATION]: Js,
    [u.FLEX_ALIGNMENT]: Ai,
    [u.FONT_SIZE]: Ni,
    [u.FONT_WEIGHT]: _i,
    [u.SPACING]: oi,
    [u.IMAGE_SIZE]: ti,
    [u.STROKE_WIDTH]: ii,
    [u.TEXT_DECORATION]: di,
    [u.TEXT_WRAPPING]: ui
  }[t](e);
}
function K(e, t, n) {
  const r = J(e);
  if (!as(n, [X.SECTION_DEFAULTS, r]))
    return t;
  const s = C(n, [X.SECTION_DEFAULTS, r], {}), i = { ...t };
  for (const a in s)
    i[a] === void 0 && (i[a] = s[a]);
  return i;
}
function z(e, t, n) {
  const r = {};
  for (const s in t) {
    const i = e[s];
    if (i === void 0)
      continue;
    const a = Li(i, t[s], n);
    r[s] = a || Oi(i, t[s]);
  }
  return r;
}
function h(e, t) {
  if (!t)
    return e || void 0;
  if (e)
    return [e, t].join("_");
}
const Si = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEXT_DIRECTION,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], Di = [Dn.BORDER], fi = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], Sr = en.styleAttributeNames, Ci = [...Si, ...Di, ...Sr];
function Dr(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: s, getNodeDescriptor: i } = e, a = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return (a ? s.evaluateCondition(a, r) : !0) ? me({
    parentNodeName: I.BLOCK,
    nodes: n,
    dataContext: r,
    getNodeDescriptor: i,
    expressionEvaluator: s
  }) : !1;
}
function pi(e) {
  const {
    attributes: t,
    children: n,
    dataContext: r,
    hostAppConfig: s,
    getInputRegistry: i,
    getNodeDescriptor: a,
    expressionEvaluator: l,
    actionCallbacks: c
  } = e;
  if (!Dr(e))
    return null;
  const E = { ...t, ...Ot.styleValues }, d = W(E, fi), N = K(I.BLOCK, d, s), S = [...Ci, ...Ot.styleAttributeNames], O = k(S, N, en.styleValues), D = { ...en.styleTypes, ...Ot.styleTypes }, p = z(O, D, s), $ = { ...O, ...p }, m = ye({
    parentNodeName: I.BLOCK,
    nodes: n,
    dataContext: r,
    hostAppConfig: s,
    getInputRegistry: i,
    getNodeDescriptor: a,
    expressionEvaluator: l,
    actionCallbacks: c
  });
  if (!m.length)
    return null;
  const y = mi($), U = y[o.ARIA_DESCRIPTION], H = y[o.TEST_ID], B = q({ "aria-description": U }), ee = h(H);
  return /* @__PURE__ */ A(
    hi,
    {
      ...B,
      id: y[o.ELEMENT_ID],
      "data-testid": ee,
      dir: y[o.TEXT_DIRECTION] || "auto",
      className: y[o.CLASS_NAME],
      $alignment: y[te.ALIGNMENT],
      $background: y[te.BACKGROUND],
      $borderColor: y[te.BORDER_COLOR],
      $borderRadius: y[te.BORDER_RADIUS],
      $borderWidth: y[Ut.BORDER_WIDTH],
      $padding: y[te.PADDING],
      children: m
    }
  );
}
function mi(e) {
  const t = b(e, [
    ...Sr,
    ...Ot.styleAttributeNames
  ]), n = Ge(e, Dn.BORDER), r = {
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.CLASS_NAME]: R(e, o.CLASS_NAME),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [o.TEST_ID]: R(e, o.TEST_ID),
    ...t,
    [te.ALIGNMENT]: _r(e, te.ALIGNMENT)
  };
  return n || (r[Ut.BORDER_WIDTH] = "0"), r;
}
const hi = f(P)`
  background: ${(e) => e.$background};
  border-color: ${(e) => e.$borderColor};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-style: solid;
  border-width: ${(e) => e.$borderWidth || "0"};
  padding: ${(e) => e.$padding || "0"};
  text-align: ${(e) => e.$alignment};
`;
function qe(e, t, n, r) {
  const { attributes: s, dataContext: i, expressionEvaluator: a } = t;
  Zs(s, n, e);
  const l = R(s, o.DATA_SOURCE), c = R(s, o.CONDITIONAL_RENDERING_EXPRESSION);
  if (!(c ? a.evaluateCondition(c, i) : !0))
    return !1;
  const d = C(i, l);
  return (d === void 0 || de(d) || je(d) && An(d) || sr(d)) && r(d);
}
var T = /* @__PURE__ */ ((e) => (e.DISPLAY_STYLE = "displayStyle", e.LABEL = "label", e.LINKIFY_VALUE_FLAG = "linkifyValue", e.LINK_TARGET = "linkTarget", e.LINK_URL = "linkUrl", e.MAX_LINES = "maxLines", e.MULTILINE_STYLE = "multilineStyle", e.VALUE = "value", e))(T || {}), w = /* @__PURE__ */ ((e) => (e.PADDING = "padding", e.LABEL_ALIGNMENT = "labelAlignment", e.LABEL_BACKGROUND = "labelBackground", e.LABEL_COLOR = "labelColor", e.LABEL_FONT_SIZE = "labelFontSize", e.LABEL_FONT_WEIGHT = "labelFontWeight", e.VALUE_ALIGNMENT = "valueAlignment", e.VALUE_BACKGROUND = "valueBackground", e.VALUE_COLOR = "valueColor", e.VALUE_FONT_SIZE = "valueFontSize", e.VALUE_FONT_WEIGHT = "valueFontWeight", e.LINK_DECORATION = "linkDecoration", e.LINK_HOVER_COLOR = "linkHoverColor", e.LINK_HOVER_DECORATION = "linkHoverDecoration", e))(w || {}), ve = /* @__PURE__ */ ((e) => (e.EXPAND_BUTTON_FONT_SIZE = "expandButtonFontSize", e.EXPAND_BUTTON_FONT_WEIGHT = "expandButtonFontWeight", e.EXPAND_BUTTON_COLOR = "expandButtonColor", e.EXPAND_BUTTON_DECORATION = "expandButtonDecoration", e.EXPAND_BUTTON_HOVER_COLOR = "expandButtonHoverColor", e.EXPAND_BUTTON_HOVER_DECORATION = "expandButtonHoverDecoration", e))(ve || {}), we = /* @__PURE__ */ ((e) => (e.LINK_TEXT = "linkText", e.OPEN_IN_PLACE = "openInPlace", e))(we || {}), ue = /* @__PURE__ */ ((e) => (e.DECIMAL_PLACES = "decimalPlaces", e.LOCALE = "locale", e))(ue || {}), fe = /* @__PURE__ */ ((e) => (e.CURRENCY_CODE_SOURCE = "currencyCodeSource", e.DEFAULT_CURRENCY_CODE = "defaultCurrencyCode", e.NEGATIVE_VALUE_STYLE = "negativeValueStyle", e))(fe || {}), fn = /* @__PURE__ */ ((e) => (e.NEGATIVE_VALUE_COLOR = "negativeValueColor", e))(fn || {}), Ce = /* @__PURE__ */ ((e) => (e.DISPLAY_TRUE_AS = "displayTrueAs", e.DISPLAY_FALSE_AS = "displayFalseAs", e))(Ce || {}), Cn = /* @__PURE__ */ ((e) => (e.FORMAT = "format", e))(Cn || {});
const fr = f(P)`
  max-height: ${(e) => {
  const t = _(e.$lineHeight), n = t && t !== "normal" ? t : "1.2";
  return /px|em|rem|ex|rex/i.test(n) ? `calc(${e.$maxLines} * ${n})` : `calc(${e.$maxLines}em * ${n})`;
}};
  overflow: scroll;
  padding: 0;
  scroll-behavior: smooth;
  white-space: pre-line;
`;
function gi(e, t) {
  const { children: n, expanded: r, maxLines: s, lineHeight: i, testId: a } = e;
  return r ? /* @__PURE__ */ A(fr, { $maxLines: s, $lineHeight: i, "data-testid": a, ref: t, children: n }) : /* @__PURE__ */ A(ht, { clamp: s, "data-testid": a, useNativeClamp: !0, children: /* @__PURE__ */ A(yi, { ref: t, children: n }) });
}
const yi = f(P)`
  white-space: pre-line;
`, $i = lr(gi);
function pn() {
  var e;
  return !!(typeof window < "u" && ((e = window == null ? void 0 : window.document) != null && e.createElement));
}
function jn(e, t) {
  if (!e || !t || !pn())
    return;
  const n = "current" in e ? e.current : e;
  if (!n)
    return;
  const r = n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight, s = n.title;
  r ? s !== t && (n.title = t) : s && (n.title = "");
}
const bi = "Show more...", Pi = "Show less";
function Ve(e) {
  const { id: t, aria: n, className: r, direction: s, displayStyle: i, label: a, maxLines: l, multilineStyle: c, testId: E, value: d } = e, { linkifyValue: N, linkDecoration: S, linkHoverColor: O, linkHoverDecoration: D, linkTarget: p, linkUrl: $ } = e, {
    expandButtonColor: m,
    expandButtonFontSize: y,
    expandButtonFontWeight: U,
    expandButtonDecoration: H,
    expandButtonHoverColor: B,
    expandButtonHoverDecoration: ee,
    padding: ce,
    labelAlignment: be,
    labelBackground: Un,
    labelColor: Yt,
    labelFontSize: Ht,
    labelFontWeight: kt,
    valueAlignment: Co,
    valueBackground: We,
    valueColor: xn,
    valueFontSize: po,
    valueFontWeight: mo
  } = e, Xe = _(a), Kt = _(d), ho = `${_(r)} datavalue`, Gn = Ie(null), Ye = Ie(null), wn = Ie(!1), [_t, go] = xe(!1), [, yo] = xe({}), Je = l > 1, $o = Je && c === Ae.EXPANDABLE, bo = Je && c === Ae.SCROLLABLE, Pe = i === g.STACKED, Po = Je && c === Ae.STATIC;
  st(() => {
    jn(Gn, Xe), jn(Ye, Kt);
  }), st(() => {
    const et = Ye.current;
    et && (wn.current = et.clientWidth < et.scrollWidth || et.clientHeight < et.scrollHeight, yo({}));
  }, []);
  const vo = Pe ? Mi : vi, Mo = Pe ? Gi : xi, Uo = Pe ? Fi : Bi, [xo, Go] = Ke(Ht), [wo, zt] = Ke(po), [Bo, Fo] = Ke(
    y || "inherit/normal"
  ), Vo = We && We !== L.INHERIT && We !== L.TRANSPARENT && We.toLowerCase() !== "white" && We.toLowerCase() !== "#ffffff", Bn = (Je || Pe) && Vo, Wo = Pe ? "0 0 2px 0" : "0 4px 0 0", Xo = Pe ? Bn ? "8px" : "0" : Bn ? `4px 8px 4px ${Xe ? "8px" : "0"}` : `0 0 0 ${Xe ? "4px" : "0"}`, Yo = ce && ce !== "0" ? ce : "1px 0", Zt = Pe ? { dir: s || "auto" } : {}, Ho = q({ "aria-description": n }), ko = h(E), Ko = h(E, "expand-toggle"), zo = h(E, "data-label"), Zo = h(E, "link"), jo = h(E, "data-value"), qo = Xe ? /* @__PURE__ */ A(
    Mo,
    {
      ...Zt,
      className: "label",
      "data-testid": zo,
      ref: Gn,
      $alignment: be,
      $background: Un,
      $color: Yt,
      $fontSize: xo,
      $fontWeight: kt,
      $lineHeight: Go,
      $padding: Wo,
      children: Xe
    }
  ) : null, Lt = N ? /* @__PURE__ */ A(
    Vi,
    {
      "data-testid": Zo,
      href: $,
      target: p,
      rel: "noreferrer",
      $color: xn,
      $decoration: S,
      $hoverColor: O,
      $hoverDecoration: D,
      children: Kt
    }
  ) : Kt;
  let Qe;
  Je ? Po ? Qe = /* @__PURE__ */ A(ht, { clamp: l, useNativeClamp: !0, children: /* @__PURE__ */ A(Wi, { ref: Ye, children: Lt }) }) : bo ? Qe = /* @__PURE__ */ A(fr, { $lineHeight: zt, $maxLines: l, ref: Ye, children: Lt }) : Qe = /* @__PURE__ */ A(
    $i,
    {
      expanded: _t,
      maxLines: _t ? On : l,
      lineHeight: zt,
      ref: Ye,
      children: Lt
    }
  ) : Qe = /* @__PURE__ */ A(ht, { clamp: 1, useNativeClamp: !0, children: /* @__PURE__ */ A("div", { ref: Ye, children: Lt }) });
  const Jo = $o && wn.current ? /* @__PURE__ */ A(
    Ui,
    {
      ...Zt,
      "data-testid": Ko,
      onClick: () => go(!_t),
      $color: m || "inherit",
      $decoration: H,
      $fontSize: Bo,
      $fontWeight: U || "500",
      $hoverColor: B,
      $hoverDecoration: ee,
      $lineHeight: Fo,
      children: _t ? Pi : bi
    }
  ) : null, Qo = /* @__PURE__ */ A(Uo, { $hasLabel: !!Xe, children: /* @__PURE__ */ Z(
    wi,
    {
      ...Zt,
      className: "value",
      "data-testid": jo,
      $alignment: Co,
      $background: We,
      $color: xn,
      $fontSize: wo,
      $fontWeight: mo,
      $lineHeight: zt,
      $padding: Xo,
      children: [
        Qe,
        Jo
      ]
    }
  ) });
  return /* @__PURE__ */ Z(
    vo,
    {
      ...Ho,
      id: t,
      className: ho,
      "data-testid": ko,
      dir: s || "auto",
      $padding: Yo,
      children: [
        qo,
        Qo
      ]
    }
  );
}
const vi = f(P)`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  padding: ${(e) => e.$padding || "0"};
  width: 100%;
  word-break: break-word;
`, Mi = f(P)`
  display: block;
  padding: ${(e) => e.$padding || "0"};
  word-break: break-word;
`, xt = Ts`
  background: ${(e) => e.$background || "inherit"};
  color: ${(e) => e.$color};
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight || "normal"};
  padding: ${(e) => e.$padding || "0"};
  text-align: ${(e) => e.$alignment || "initial"};
  text-decoration: ${(e) => e.$decoration || "none"};

  &:hover {
    color: ${(e) => e.$hoverColor || e.$color};
    text-decoration: ${(e) => e.$hoverDecoration || e.$decoration || "none"};
  }
`, Ui = f(P)`
  ${xt};
  cursor: pointer;
  margin-bottom: -2px;
  padding-top: 6px;
`, xi = f(P)`
  ${xt};
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, Gi = f(P)`
  ${xt};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, wi = f(P)`
  ${xt};
  width: 100%;
`, Bi = f(P)`
  display: flex;
  width: ${(e) => e.$hasLabel ? "60%" : "100%"};
`, Fi = f(P)`
  display: flex;
  width: 100%;
`, Vi = f.a`
  color: ${(e) => e.$color};
  cursor: pointer;
  text-decoration: ${(e) => e.$decoration || "initial"};

  &:hover {
    color: ${(e) => e.$hoverColor || e.$color};
    text-decoration: ${(e) => e.$hoverDecoration || e.$decoration || "initial"};
  }
`, Wi = f(P)`
  white-space: pre-line;
`, $e = new M({
  [w.PADDING]: { style: G.NONE, styleType: u.SPACING },
  [w.LABEL_ALIGNMENT]: { style: ie.LEFT, styleType: u.ALIGNMENT },
  [w.LABEL_BACKGROUND]: { style: L.INHERIT, styleType: u.COLOR },
  [w.LABEL_COLOR]: { style: v.DEFAULT_TEXT, styleType: u.COLOR },
  [w.LABEL_FONT_SIZE]: { style: le.DEFAULT, styleType: u.FONT_SIZE },
  [w.LABEL_FONT_WEIGHT]: {
    style: Ee.REGULAR,
    styleType: u.FONT_WEIGHT
  },
  [w.VALUE_ALIGNMENT]: { style: ie.LEFT, styleType: u.ALIGNMENT },
  [w.VALUE_BACKGROUND]: { style: L.INHERIT, styleType: u.COLOR },
  [w.VALUE_COLOR]: { style: v.DEFAULT_TEXT, styleType: u.COLOR },
  [w.VALUE_FONT_SIZE]: { style: le.DEFAULT, styleType: u.FONT_SIZE },
  [w.VALUE_FONT_WEIGHT]: {
    style: Ee.REGULAR,
    styleType: u.FONT_WEIGHT
  },
  [w.LINK_DECORATION]: {
    style: Re.NONE,
    styleType: u.TEXT_DECORATION
  },
  [w.LINK_HOVER_COLOR]: {
    style: v.DEFAULT_TEXT,
    styleType: u.COLOR
  },
  [w.LINK_HOVER_DECORATION]: {
    style: Re.NONE,
    styleType: u.TEXT_DECORATION
  }
}), Gt = new M($e.styles), Xi = [
  Ce.DISPLAY_FALSE_AS,
  Ce.DISPLAY_TRUE_AS,
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.LABEL
], Yi = [
  Ce.DISPLAY_FALSE_AS,
  Ce.DISPLAY_TRUE_AS,
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.TEXT_DIRECTION,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.LABEL,
  T.DISPLAY_STYLE
], Hi = [...Yi, ...Gt.styleAttributeNames], ki = {
  ...Gt.styleValues,
  [Ce.DISPLAY_FALSE_AS]: "No",
  [Ce.DISPLAY_TRUE_AS]: "Yes",
  [o.TEXT_DIRECTION]: ae.AUTO,
  [T.DISPLAY_STYLE]: g.ROW
};
function Cr(e) {
  const t = (n) => (de(n) && _(n) && pr(n), de(n) && !!_(n) || je(n) && An(n) || sr(n));
  return qe(I.BOOLEAN_VALUE, e, [o.DATA_SOURCE], t);
}
function Ki(e) {
  const { attributes: t, dataContext: n, hostAppConfig: r } = e;
  if (!Cr(e))
    return null;
  const s = W(t, Xi), i = K(I.BOOLEAN_VALUE, s, r), a = k(Hi, i, ki), l = z(a, Gt.styleTypes, r), c = { ...a, ...l }, E = R(c, o.DATA_SOURCE), d = zi(c), N = pr(C(n, E)), S = R(c, Ce.DISPLAY_FALSE_AS), O = R(c, Ce.DISPLAY_TRUE_AS);
  return /* @__PURE__ */ A(Ve, { ...d, value: N ? O : S });
}
function zi(e) {
  const t = b(e, Gt.styleAttributeNames);
  return {
    // Functional props
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.CLASS_NAME]: R(e, o.CLASS_NAME),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [o.TEST_ID]: R(e, o.TEST_ID),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [T.DISPLAY_STYLE]: Q(
      e,
      T.DISPLAY_STYLE,
      [g.STACKED, g.ROW],
      g.ROW
    ),
    [T.LABEL]: R(e, T.LABEL),
    [T.LINKIFY_VALUE_FLAG]: !1,
    [T.MAX_LINES]: 1,
    // Styling props
    ...t
  };
}
function pr(e) {
  if (de(e))
    switch (_(e).toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "yes":
        return !0;
      case "no":
        return !1;
      default:
        throw Error(`Unexpected data value: '${e}'`);
    }
  return !!e;
}
function Zi(e) {
  const { children: t, emitGlobalStyles: n, ...r } = e, s = r[gt.HOST_DEFAULT_STYLES] || {}, i = n ? {} : s, a = e[o.ARIA_DESCRIPTION], l = e[o.TEST_ID], c = q({ "aria-description": a }), E = h(l), d = n && !mt(s) ? As(() => ({ ...s })) : us.Fragment;
  return /* @__PURE__ */ Z(ds, { children: [
    /* @__PURE__ */ A(d, {}),
    /* @__PURE__ */ A(
      ji,
      {
        ...c,
        id: e[o.ELEMENT_ID],
        className: e[o.CLASS_NAME],
        "data-testid": E,
        $globalStyles: i,
        $background: r[it.BACKGROUND_COLOR],
        $padding: r[it.PADDING],
        children: /* @__PURE__ */ A("div", { children: t })
      }
    )
  ] });
}
const ji = f.div((e) => ({
  ...e.$globalStyles,
  background: e.$background || "transparent",
  boxShadow: "none",
  padding: e.$padding || 0
})), St = new M({
  [it.BACKGROUND_COLOR]: { style: L.TRANSPARENT, styleType: u.COLOR },
  [it.PADDING]: { style: G.NONE, styleType: u.SPACING }
}), mn = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID
], qi = mn;
function mr(e) {
  const { parentNodeName: t, children: n, dataContext: r, expressionEvaluator: s, getNodeDescriptor: i } = e;
  if (t)
    throw Error(`<${I.CARD}> cannot be a child of any other component`);
  return me({
    parentNodeName: I.CARD,
    nodes: n,
    dataContext: r,
    expressionEvaluator: s,
    getNodeDescriptor: i
  });
}
function Ji(e) {
  const {
    attributes: t,
    children: n,
    dataContext: r,
    hostAppConfig: s,
    expressionEvaluator: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    options: c,
    actionCallbacks: E
  } = e;
  if (!mr(e))
    return null;
  const d = ye({
    parentNodeName: I.CARD,
    nodes: n,
    dataContext: r,
    hostAppConfig: s,
    expressionEvaluator: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    actionCallbacks: E
  });
  if (c != null && c.returnUnwrappedNodes)
    return d;
  const N = [...mn, ...St.styleAttributeNames], S = W(t, qi), O = K(I.CARD, S, s), D = k(N, O, St.styleValues), p = St.styleTypes, $ = z(D, p, s), m = { ...D, ...$ }, y = Qi(m, s, !!(c != null && c.useShadowDOM));
  return /* @__PURE__ */ A(Zi, { ...y, children: d });
}
function Qi(e, t, n) {
  const r = b(e, mn), s = b(e, St.styleAttributeNames), i = C(t, X.SECTION_GLOBAL_STYLES) || {};
  return {
    ...r,
    ...s,
    [gt.HOST_DEFAULT_STYLES]: ea(i),
    [gt.EMIT_GLOBAL_STYLES]: n
  };
}
function ea(e) {
  return !_n(e) || mt(e) ? {} : Object.keys(e).includes("*") ? e : { "*": { ...e } };
}
var hn = /* @__PURE__ */ ((e) => (e.SPACING = "columnSpacing", e))(hn || {});
const tn = new M({
  [hn.SPACING]: { style: G.SMALL, styleType: u.SPACING }
});
var Be = /* @__PURE__ */ ((e) => (e.HEIGHT = "height", e.WIDTH = "width", e))(Be || {}), ct = /* @__PURE__ */ ((e) => (e.HORIZONTAL_ALIGNMENT = "alignment", e.VERTICAL_ALIGNMENT = "verticalAlignment", e))(ct || {});
const gn = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], hr = tn.styleAttributeNames, ta = [...gn, ...hr];
function gr(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: s, getNodeDescriptor: i } = e;
  oa(n);
  const a = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return (a ? s.evaluateCondition(a, r) : !0) && me({
    parentNodeName: I.COLUMN_GROUP,
    nodes: n,
    dataContext: r,
    getNodeDescriptor: i,
    expressionEvaluator: s
  });
}
function na(e) {
  const {
    actionCallbacks: t,
    attributes: n,
    children: r,
    dataContext: s,
    expressionEvaluator: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    hostAppConfig: c
  } = e;
  if (!gr(e))
    return null;
  const E = W(n, gn), d = K(I.COLUMN_GROUP, E, c), N = k(
    ta,
    d,
    tn.styleValues
  ), S = z(N, tn.styleTypes, c), O = { ...N, ...S }, D = sa(O), p = ye({
    parentNodeName: I.COLUMN_GROUP,
    nodes: r,
    dataContext: s,
    expressionEvaluator: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    hostAppConfig: c,
    actionCallbacks: t
  }), $ = D[o.TEST_ID], m = q({ "aria-description": D[o.ARIA_DESCRIPTION] });
  return /* @__PURE__ */ A(
    ia,
    {
      ...m,
      id: D[o.ELEMENT_ID],
      className: D[o.CLASS_NAME],
      "data-testid": $,
      $gap: D[hn.SPACING],
      $gridColumns: ra(r),
      children: p
    }
  );
}
function ra(e) {
  const t = (e || []).reduce((n, r) => {
    if (De(r)) {
      const s = (r.attributes[Be.WIDTH] || "").toLowerCase() || He.AUTO;
      if (!(Ze(s, [He.AUTO, He.STRETCH]) || Or(s)))
        throw Error(`Cannot render <${I.COLUMN_GROUP}> - invalid column width "${s}"`);
      switch (s) {
        case He.AUTO:
          n.push("auto");
          break;
        case He.STRETCH:
          n.push("100fr");
          break;
        default:
          n.push(s);
          break;
      }
    }
    return n;
  }, []);
  return t.length ? t.join(" ") : "auto";
}
function oa(e) {
  if (e != null && e.length) {
    for (const t of e)
      if (!(Ln(t) || De(t) && t.name === I.COLUMN))
        throw Error(`<${I.COLUMN_GROUP}> can only have <${I.COLUMN}> children`);
  }
}
function sa(e) {
  const t = b(e, gn), n = b(e, hr);
  return { ...t, ...n };
}
const ia = f.div`
  display: grid;
  align-items: start;
  gap: ${(e) => e.$gap};
  grid-template-columns: ${(e) => e.$gridColumns};
  grid-template-rows: none;
  justify-items: start;
  overflow: hidden;
  width: 100%;
`, yn = new M({
  [ct.HORIZONTAL_ALIGNMENT]: {
    style: Le.LEFT,
    styleType: u.FLEX_ALIGNMENT
  },
  [ct.VERTICAL_ALIGNMENT]: {
    style: Le.TOP,
    styleType: u.FLEX_ALIGNMENT
  }
}), $n = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID
], yr = [Be.HEIGHT], $r = yn.styleAttributeNames, aa = [...$n, ...yr, ...$r], ca = {
  ...yn.styleValues,
  [Be.HEIGHT]: Sn.FULL
};
function br(e) {
  if (e.parentNodeName !== I.COLUMN_GROUP)
    throw Error(`<${I.COLUMN}> must be a child of a <${I.COLUMN_GROUP}>`);
  return !0;
}
function la(e) {
  const {
    actionCallbacks: t,
    attributes: n,
    children: r,
    dataContext: s,
    expressionEvaluator: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    hostAppConfig: c
  } = e;
  br(e);
  const E = W(n, [...$n, ...yr]), d = K(I.COLUMN, E, c), N = k(aa, d, ca), S = z(N, yn.styleTypes, c), O = { ...N, ...S }, D = Ea(O), p = ye({
    parentNodeName: I.COLUMN,
    nodes: r,
    dataContext: s,
    expressionEvaluator: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    hostAppConfig: c,
    actionCallbacks: t
  }), $ = q({ "aria-description": D[o.ARIA_DESCRIPTION] }), m = {
    id: D[o.ELEMENT_ID],
    className: D[o.CLASS_NAME],
    "data-testid": h(D[o.TEST_ID]),
    $align: D[ct.HORIZONTAL_ALIGNMENT],
    $valign: D[ct.VERTICAL_ALIGNMENT],
    $height: D[Be.HEIGHT]
  };
  return /* @__PURE__ */ A(da, { ...$, ...m, children: p });
}
function Ea(e) {
  const t = b(e, $n), n = b(e, $r), r = R(e, Be.HEIGHT);
  if (!(Ze(r, [Sn.AUTO]) || Or(r)))
    throw Error(`Cannot render <${I.COLUMN}> - invalid height "${r}"`);
  return {
    ...t,
    ...n,
    [Be.HEIGHT]: r
  };
}
const da = f(P)`
  display: flex;
  align-items: ${(e) => e.$align};
  flex-direction: column;
  justify-content: ${(e) => e.$valign};
  height: ${(e) => e.$height || "100%"};
  width: 100%;
`, wt = new M({
  ...$e.styles,
  [fn.NEGATIVE_VALUE_COLOR]: {
    style: v.DEFAULT_TEXT,
    styleType: u.COLOR
  }
}), Pr = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  fe.CURRENCY_CODE_SOURCE,
  fe.DEFAULT_CURRENCY_CODE,
  T.LABEL,
  ue.DECIMAL_PLACES,
  ue.LOCALE
], ua = [
  ...Pr,
  o.TEXT_DIRECTION,
  fe.NEGATIVE_VALUE_STYLE,
  T.DISPLAY_STYLE
], Ta = [...ua, ...wt.styleAttributeNames], Aa = {
  ...wt.styleValues,
  [o.TEXT_DIRECTION]: ae.AUTO,
  [fe.DEFAULT_CURRENCY_CODE]: "USD",
  [fe.NEGATIVE_VALUE_STYLE]: ot.STANDARD,
  [T.DISPLAY_STYLE]: g.ROW,
  [ue.DECIMAL_PLACES]: "2"
};
function vr(e) {
  const t = (n) => de(n) && !!_(n) || je(n) && isFinite(n);
  return qe(I.CURRENCY_VALUE, e, [o.DATA_SOURCE], t);
}
function Ia(e) {
  const { attributes: t, dataContext: n, hostAppConfig: r } = e;
  if (!vr(e))
    return null;
  const s = W(t, Pr), i = K(I.CURRENCY_VALUE, s, r), a = k(Ta, i, Aa), l = z(a, wt.styleTypes, r), c = { ...a, ...l }, E = R(a, o.DATA_SOURCE), d = C(n, E), N = Number(d);
  if (Number.isNaN(N))
    throw Error(`Unable to render <${I.CURRENCY_VALUE}>. Invalid value: "${d}"`);
  N < 0 && (c[w.VALUE_COLOR] = c[fn.NEGATIVE_VALUE_COLOR]);
  const S = _a(c), O = Ra(N, c, n);
  return /* @__PURE__ */ A(Ve, { ...S, value: O });
}
function Ra(e, t, n) {
  const r = Math.max(At(t, ue.DECIMAL_PLACES), 0), s = R(t, ue.LOCALE) || navigator.language, i = Q(
    t,
    fe.NEGATIVE_VALUE_STYLE,
    [ot.ACCOUNTING, ot.STANDARD],
    ot.STANDARD
  );
  try {
    return Intl.NumberFormat(s, {
      style: "currency",
      currency: Na(t, n),
      currencySign: i,
      minimumFractionDigits: r,
      maximumFractionDigits: r
    }).format(e);
  } catch (a) {
    throw Error(`Unable to render <CurrencyValue>. ${a.message}`);
  }
}
function Na(e, t) {
  const n = R(e, fe.DEFAULT_CURRENCY_CODE), r = R(e, fe.CURRENCY_CODE_SOURCE), s = r ? C(t, r, n) : n;
  return de(s) && _(s) ? _(s).toUpperCase() : n.toUpperCase();
}
function _a(e) {
  const t = b(e, wt.styleAttributeNames);
  return {
    // Functional props
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.CLASS_NAME]: R(e, o.CLASS_NAME),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [o.TEST_ID]: R(e, o.TEST_ID),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [T.DISPLAY_STYLE]: Q(
      e,
      T.DISPLAY_STYLE,
      [g.STACKED, g.ROW],
      g.ROW
    ),
    [T.LABEL]: R(e, T.LABEL),
    [T.LINKIFY_VALUE_FLAG]: !1,
    [T.MAX_LINES]: 1,
    // Styling props
    ...t
  };
}
const Bt = new M($e.styles), Mr = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.LABEL,
  Cn.FORMAT
], La = [
  ...Mr,
  o.TEXT_DIRECTION,
  T.DISPLAY_STYLE
], Oa = [...La, ...Bt.styleAttributeNames], Sa = {
  ...Bt.styleValues,
  [o.TEXT_DIRECTION]: ae.AUTO,
  [T.DISPLAY_STYLE]: g.ROW
};
function Ur(e) {
  const t = (n) => de(n) && !!_(n);
  return qe(I.DATETIME_VALUE, e, [o.DATA_SOURCE], t);
}
function Da(e) {
  const { attributes: t, dataContext: n, hostAppConfig: r } = e;
  if (!Ur(e))
    return null;
  const s = W(t, Mr), i = K(I.DATETIME_VALUE, s, r), a = k(Oa, i, Sa), l = z(a, Bt.styleTypes, r), c = { ...a, ...l }, E = Ca(c), d = fa(c, n);
  return /* @__PURE__ */ A(Ve, { ...E, value: d });
}
function fa(e, t) {
  const n = R(e, o.DATA_SOURCE), r = R(e, Cn.FORMAT), s = _(String(C(t, n))), i = Rs(s);
  if (!i.isValid())
    throw Error(`Unable to render <${I.DATETIME_VALUE}>. Invalid value: "${s}"`);
  return r ? i.format(r) : s.indexOf("T") !== -1 ? i.format("MMM D, YYYY h:mm A") : i.format("MMM D, YYYY");
}
function Ca(e) {
  const t = b(e, Bt.styleAttributeNames);
  return {
    // Functional props
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.CLASS_NAME]: R(e, o.CLASS_NAME),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [o.TEST_ID]: R(e, o.TEST_ID),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [T.DISPLAY_STYLE]: Q(
      e,
      T.DISPLAY_STYLE,
      [g.STACKED, g.ROW],
      g.ROW
    ),
    [T.LABEL]: R(e, T.LABEL),
    [T.LINKIFY_VALUE_FLAG]: !1,
    [T.MAX_LINES]: 1,
    // Styling props
    ...t
  };
}
var Ne = /* @__PURE__ */ ((e) => (e.LINE_COLOR = "color", e.LINE_WIDTH = "thickness", e.SPACING = "spacing", e))(Ne || {});
const nn = new M({
  [Ne.LINE_COLOR]: { style: v.BORDER, styleType: u.COLOR },
  [Ne.LINE_WIDTH]: { style: oe.THIN, styleType: u.STROKE_WIDTH },
  [Ne.SPACING]: { style: G.SMALL, styleType: u.SPACING }
}), xr = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], Gr = nn.styleAttributeNames, pa = [...xr, ...Gr];
function wr(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r } = e, s = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return s ? r.evaluateCondition(s, n) : !0;
}
function ma(e) {
  const { attributes: t, hostAppConfig: n } = e;
  if (!wr(e))
    return null;
  const r = W(t, xr), s = K(I.DIVIDER, r, n), i = k(
    pa,
    s,
    nn.styleValues
  ), a = z(i, nn.styleTypes, n), l = { ...i, ...a }, c = ha(l), E = c[o.ARIA_DESCRIPTION], d = c[o.TEST_ID], N = q({ "aria-description": E }), S = h(d), O = h(d, "divider-line");
  return /* @__PURE__ */ A(
    ga,
    {
      ...N,
      id: c[o.ELEMENT_ID],
      className: c[o.CLASS_NAME],
      "data-testid": S,
      $padding: c[Ne.SPACING],
      children: /* @__PURE__ */ A(
        ya,
        {
          "data-testid": O,
          $lineColor: c[Ne.LINE_COLOR],
          $lineWidth: c[Ne.LINE_WIDTH]
        }
      )
    }
  );
}
function ha(e) {
  const t = b(e, [
    o.ARIA_DESCRIPTION,
    o.CLASS_NAME,
    o.ELEMENT_ID,
    o.TEST_ID
  ]), n = b(e, Gr);
  return {
    ...t,
    ...n
  };
}
const ga = f(P)`
  display: block;
  padding: ${(e) => e.$padding} 0;
  width: 100%;
`, ya = f(P)`
  background-color: ${(e) => e.$lineColor};
  height: ${(e) => e.$lineWidth};
`;
function Br(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: s, getNodeDescriptor: i } = e;
  ba(n);
  const a = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  if (a ? s.evaluateCondition(a, r) : !0) {
    const c = at(n, I.DRAWER_FIXED_PART);
    return Fr({
      children: c == null ? void 0 : c.children,
      dataContext: r,
      getNodeDescriptor: i,
      expressionEvaluator: s,
      parentNodeName: I.DRAWER
    });
  }
  return !1;
}
function Fr(e) {
  return Vr(I.DRAWER_FIXED_PART, e);
}
function $a(e) {
  return Vr(I.DRAWER_EXPANDABLE_PART, e);
}
function Vr(e, t) {
  const { children: n, dataContext: r, expressionEvaluator: s, getNodeDescriptor: i, parentNodeName: a } = t;
  if (a !== I.DRAWER)
    throw Error(`"${e}" must be a child of "${I.DRAWER}"`);
  return me({
    nodes: n,
    dataContext: r,
    getNodeDescriptor: i,
    expressionEvaluator: s,
    parentNodeName: e
  });
}
function ba(e) {
  const t = e ? e.filter((s) => !Ln(s)) : [], n = at(t, I.DRAWER_FIXED_PART), r = at(t, I.DRAWER_EXPANDABLE_PART);
  if (!(t.length === 2 && n && r))
    throw Error(`Invalid "${I.DRAWER}" component syntax`);
}
var ge = /* @__PURE__ */ ((e) => (e.BORDER = "border", e.INITIAL_STATE = "initialState", e))(ge || {}), lt = /* @__PURE__ */ ((e) => (e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e))(lt || {}), Ft = /* @__PURE__ */ ((e) => (e.BORDER_WIDTH = "borderWidth", e))(Ft || {}), Se = /* @__PURE__ */ ((e) => (e.ACTIVE_BACKGROUND = "activeBackground", e.BACKGROUND = "background", e.HOVER_BACKGROUND = "hoverBackground", e.PADDING = "padding", e))(Se || {}), bn = /* @__PURE__ */ ((e) => (e.ICON_COLOR = "iconColor", e))(bn || {}), Et = /* @__PURE__ */ ((e) => (e.BACKGROUND = "background", e.PADDING = "padding", e))(Et || {});
const bt = new M({
  [lt.BORDER_COLOR]: { style: v.BORDER, styleType: u.COLOR },
  [lt.BORDER_RADIUS]: { style: re.X_SMALL, styleType: u.BORDER_RADIUS }
}), Pt = new M({
  [Ft.BORDER_WIDTH]: { style: oe.THIN, styleType: u.STROKE_WIDTH }
}), rn = new M({
  [Se.ACTIVE_BACKGROUND]: { style: L.GREY_100, styleType: u.COLOR },
  [Se.BACKGROUND]: { style: L.TRANSPARENT, styleType: u.COLOR },
  [Se.HOVER_BACKGROUND]: { style: L.GREY_100, styleType: u.COLOR },
  [Se.PADDING]: { style: G.MEDIUM, styleType: u.SPACING }
}), on = new M({
  [bn.ICON_COLOR]: {
    style: v.DEFAULT_TEXT,
    styleType: u.COLOR
  }
}), sn = new M({
  [Et.BACKGROUND]: { style: L.TRANSPARENT, styleType: u.COLOR },
  [Et.PADDING]: { style: G.MEDIUM, styleType: u.SPACING }
});
function Wr(e) {
  const t = e.viewBox || "0 0 16 16";
  return /* @__PURE__ */ A("svg", { preserveAspectRatio: "xMidYMid meet", ...e, viewBox: t, children: /* @__PURE__ */ A(
    "path",
    {
      clipRule: "evenodd",
      d: `M1.64645 4.64645C1.84171 4.45118 2.15829 4.45118 2.35355 4.64645L8 10.2929L13.6464
          4.64645C13.8417 4.45118 14.1583 4.45118 14.3536 4.64645C14.5488 4.84171 14.5488 5.15829 14.3536
          5.35355L8.35355 11.3536C8.15829 11.5488 7.84171 11.5488 7.64645 11.3536L1.64645 5.35355C1.45118 5.15829
          1.45118 4.84171 1.64645 4.64645Z`,
      fillRule: "evenodd"
    }
  ) });
}
const qn = 8, ke = 4, Dt = 14, Pa = Lr(L.GREY_300);
function va(e) {
  const t = h(e[o.TEST_ID]), n = h(t, "content"), r = h(t, "icon"), s = q({ "aria-description": e[o.ARIA_DESCRIPTION] }), i = e.isInteractive && e.isExpanded, a = Nn({
    to: {
      transform: i ? "rotate(0deg)" : "rotate(-90deg)"
    },
    config: {
      clamp: !0,
      friction: 20,
      tension: 200
    },
    onRest: e.onAnimationEnd
  }), l = i ? e[Se.ACTIVE_BACKGROUND] : e[Se.BACKGROUND], c = e.isInteractive ? "pointer" : "default", E = e.isInteractive ? e[bn.ICON_COLOR] : Pa, d = e.isInteractive ? e.onClick : void 0;
  return /* @__PURE__ */ Z(
    Ua,
    {
      ...s,
      id: e[o.ELEMENT_ID],
      className: _(e[o.CLASS_NAME]),
      "data-testid": t,
      onClick: d,
      $background: l,
      $cursor: c,
      $hoverBackground: e[Se.HOVER_BACKGROUND],
      children: [
        /* @__PURE__ */ A(xa, { "data-testid": n, $padding: e[Se.PADDING], children: e.children }),
        /* @__PURE__ */ A(Ma, { "data-testid": r, style: a, $fillColor: E, children: /* @__PURE__ */ A(Wr, {}) })
      ]
    }
  );
}
const Ma = f(vt.div)`
  display: flex;
  fill: ${(e) => e.$fillColor};
  height: ${Dt + 2 * ke}px;
  min-width: ${Dt + 2 * ke}px;
  padding: ${ke}px;
  position: relative;
  width: ${Dt + 2 * ke}px;
`, Ua = f(P)`
  align-items: center;
  background: ${(e) => e.$background || "transparent"};
  cursor: ${(e) => e.$cursor};
  display: flex;
  padding-right: ${ke}px;

  &:hover {
    background: ${(e) => e.$hoverBackground || e.$background || "transparent"};
  }
`, xa = f(P)`
  max-width: calc(100% - ${Dt + qn + 2 * ke}px);
  margin-right: ${qn}px;
  padding: ${(e) => `${e.$padding} 2px ${e.$padding} ${e.$padding}` || "0"};
  width: 100%;
`;
function Xr(e, t, n, r) {
  const s = Ie(0), i = {
    height: "auto"
  }, a = Ie(e), l = !e && !a.current, [, c] = xe({}), E = Nn({
    to: {
      opacity: e ? 0 : 1,
      height: e ? 0 : s.current || 0
    },
    config: {
      clamp: !0,
      friction: 20,
      tension: n || 200
    },
    onRest: () => {
      r && r(), a.current = e, e || c({});
    }
  });
  return Ns(() => {
    if (!(t != null && t.current))
      return;
    const d = s.current;
    s.current = t.current.offsetHeight || 0, d !== s.current && c({});
  }, [t]), l ? i : E;
}
function Ga({
  fixedPart: e,
  expandablePart: t,
  isExpanded: n,
  onAnimationEnd: r,
  ...s
}) {
  const i = !!(t != null && t.content), [a, l] = xe(i && n), c = Ie(null), E = h(s[o.TEST_ID]), d = h(E, "fixed"), N = h(E, "expandable"), S = h(E, "expandable-content"), O = q({ "aria-description": s[o.ARIA_DESCRIPTION] }), D = q({ "aria-description": e.props[o.ARIA_DESCRIPTION] }), p = { [o.TEST_ID]: d }, $ = () => {
    l((be) => !be);
  }, m = r && i, y = Fn(), U = Fn(), H = m ? y.resolve : void 0, B = m ? U.resolve : void 0;
  m && Promise.all([y.promise, U.promise]).then(() => r());
  const ee = Xr(
    !a,
    c,
    200,
    B
  ), ce = i ? /* @__PURE__ */ A(Fa, { "data-testid": N, style: ee, children: /* @__PURE__ */ A("div", { ref: c, children: /* @__PURE__ */ A(
    Ba,
    {
      "data-testid": S,
      $background: t.props[Et.BACKGROUND],
      $padding: t.props[Et.PADDING],
      children: t.content
    }
  ) }) }) : null;
  return /* @__PURE__ */ Z(
    wa,
    {
      ...O,
      id: s[o.ELEMENT_ID],
      className: s[o.CLASS_NAME],
      "data-testid": E,
      $borderColor: s[lt.BORDER_COLOR],
      $borderRadius: s[lt.BORDER_RADIUS],
      $borderWidth: s[Ft.BORDER_WIDTH],
      children: [
        /* @__PURE__ */ A(
          va,
          {
            ...e.props,
            ...D,
            ...p,
            isInteractive: i,
            isExpanded: i && a,
            onAnimationEnd: H,
            onClick: i ? $ : void 0,
            children: e.content
          }
        ),
        ce
      ]
    }
  );
}
const wa = f(P)`
  border-color: ${(e) => e.$borderColor || "transparent"};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-style: solid;
  border-width: ${(e) => e.$borderWidth || "0"};

  & + & {
    margin-top: 4px;
  }
`, Ba = f(P)`
  background: ${(e) => e.$background || "transparent"};
  padding: ${(e) => `0 ${e.$padding || "0"} ${e.$padding || "0"} ${e.$padding || "0"}`};

  margin-top: 8px;
`, Fa = f(vt.div)`
  overflow: hidden;
`, It = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID
], Va = [
  ...It,
  ge.BORDER,
  ge.INITIAL_STATE,
  ...bt.styleAttributeNames,
  ...Pt.styleAttributeNames
], Yr = [
  ...It,
  ...rn.styleAttributeNames,
  ...on.styleAttributeNames
], Hr = [...It, ...sn.styleAttributeNames], Wa = It;
function Xa(e) {
  if (!Br(e))
    return null;
  const {
    actionCallbacks: t,
    attributes: n,
    children: r,
    dataContext: s,
    hostAppConfig: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    expressionEvaluator: c
  } = e, E = at(r, I.DRAWER_FIXED_PART), d = at(r, I.DRAWER_EXPANDABLE_PART), N = me({
    nodes: d == null ? void 0 : d.children,
    dataContext: s,
    getNodeDescriptor: l,
    expressionEvaluator: c
  }), S = jt(
    I.DRAWER,
    { ...n, ...Pt.styleValues },
    Va,
    bt.styleValues,
    { ...bt.styleTypes, ...Pt.styleTypes },
    i
  ), O = jt(
    I.DRAWER_FIXED_PART,
    { ...E == null ? void 0 : E.attributes, ...on.styleValues },
    Yr,
    rn.styleValues,
    { ...rn.styleTypes, ...on.styleTypes },
    i
  ), D = jt(
    I.DRAWER_EXPANDABLE_PART,
    d == null ? void 0 : d.attributes,
    Hr,
    sn.styleValues,
    sn.styleTypes,
    i
  ), p = Ya(S), $ = Ha(O), m = ka(D), y = pn() && N, U = s.__index === 0, H = y && (p[ge.INITIAL_STATE] === Me.EXPANDED || U && p[ge.INITIAL_STATE] === Me.EXPAND_FIRST), B = ye({
    nodes: E == null ? void 0 : E.children,
    dataContext: s,
    hostAppConfig: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    expressionEvaluator: c,
    actionCallbacks: t
  }), ee = y ? ye({
    nodes: d == null ? void 0 : d.children,
    dataContext: s,
    hostAppConfig: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    expressionEvaluator: c,
    actionCallbacks: t
  }) : null;
  return /* @__PURE__ */ A(
    Ga,
    {
      ...p,
      fixedPart: { content: B, props: $ },
      expandablePart: { content: ee, props: m },
      isExpanded: H
    }
  );
}
function jt(e, t, n, r, s, i) {
  if (!t)
    return {};
  const a = W(t, Wa), l = K(e, a, i), c = k(n, l, r), E = z(c, s, i);
  return { ...c, ...E };
}
function Ya(e) {
  const t = b(e, It), n = b(e, bt.styleAttributeNames), r = b(e, Pt.styleAttributeNames), s = Ge(e, ge.BORDER), i = {
    ...t,
    ...n,
    ...r,
    [ge.INITIAL_STATE]: Q(
      e,
      ge.INITIAL_STATE,
      [Me.COLLAPSED, Me.EXPANDED, Me.EXPAND_FIRST],
      Me.COLLAPSED
    )
  };
  return s || (i[Ft.BORDER_WIDTH] = "0"), i;
}
function Ha(e) {
  return b(e, Yr);
}
function ka(e) {
  return b(e, Hr);
}
const Vt = new M($e.styles), kr = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.LABEL
], Ka = [
  ...kr,
  o.TEXT_DIRECTION,
  T.DISPLAY_STYLE
], za = [...Ka, ...Vt.styleAttributeNames], Za = {
  ...Vt.styleValues,
  [o.TEXT_DIRECTION]: ae.AUTO,
  [T.DISPLAY_STYLE]: g.ROW
};
function Kr(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: s } = e, i = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return (i ? s.evaluateCondition(i, r) : !0) ? !!zr(n || [], r, s) : !1;
}
function ja(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: s, hostAppConfig: i } = e;
  if (!Kr(e))
    return null;
  const a = W(t, kr), l = K(I.FORMULA, a, i), c = k(za, l, Za), E = z(c, Vt.styleTypes, i), d = { ...c, ...E }, N = qa(d), S = zr(n || [], r, s);
  return /* @__PURE__ */ A(Ve, { ...N, value: S });
}
function qa(e) {
  const t = b(e, Vt.styleAttributeNames);
  return {
    // Functional props
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.CLASS_NAME]: R(e, o.CLASS_NAME),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [o.TEST_ID]: R(e, o.TEST_ID),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [T.DISPLAY_STYLE]: Q(
      e,
      T.DISPLAY_STYLE,
      [g.STACKED, g.ROW],
      g.ROW
    ),
    [T.LABEL]: R(e, T.LABEL),
    [T.LINKIFY_VALUE_FLAG]: !1,
    [T.MAX_LINES]: 1,
    // Styling props
    ...t
  };
}
function zr(e, t, n) {
  return e.length ? e.reduce((r, s) => {
    if (Mt(s)) {
      const i = n.interpolateString(s.text, t);
      return r + _(i);
    } else
      throw Error("Unexpected formula child");
  }, "") : "";
}
var F = /* @__PURE__ */ ((e) => (e.BORDER = "border", e.DEFAULT_URL = "defaultUrl", e.IMAGE_SHAPE = "shape", e.FIT_MODE = "mode", e))(F || {}), ze = /* @__PURE__ */ ((e) => (e.DISPLAY_ERROR = "displayError", e.IMAGE_URL = "url", e))(ze || {}), dt = /* @__PURE__ */ ((e) => (e.BORDER_COLOR = "borderColor", e.IMAGE_SIZE = "size", e))(dt || {}), ut = /* @__PURE__ */ ((e) => (e.BORDER_RADIUS = "borderRadius", e.BORDER_WIDTH = "borderWidth", e))(ut || {});
function Ja(e) {
  const t = e.viewBox || "0 0 16 16";
  return /* @__PURE__ */ A("svg", { preserveAspectRatio: "xMidYMid meet", fill: "none", ...e, viewBox: t, children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.00129 14.9996H14.0001C14.7434 14.9996 15.2269 14.2173 14.8945 13.5524L8.89512 1.55281C8.5266 0.81573 7.47476 0.81573 7.10624 1.55281L1.10685 13.5524C0.774423 14.2173 1.25792 14.9996 2.00129 14.9996ZM8.5093 12.459C8.5093 12.7392 8.28194 12.9665 8.00147 12.9665C7.72101 12.9665 7.49365 12.7392 7.49365 12.459C7.49365 12.1787 7.72101 11.9515 8.00147 11.9515C8.28194 11.9515 8.5093 12.1787 8.5093 12.459ZM8.50147 5.85719C8.50147 5.58105 8.27762 5.35719 8.00147 5.35719C7.72533 5.35719 7.50147 5.58105 7.50147 5.85719V9.92006C7.50147 10.1962 7.72533 10.4201 8.00147 10.4201C8.27762 10.4201 8.50147 10.1962 8.50147 9.92006V5.85719Z"
    }
  ) });
}
function Qa(e) {
  const t = e.viewBox || "0 0 16 16";
  return /* @__PURE__ */ A("svg", { preserveAspectRatio: "xMidYMid meet", fill: "none", ...e, viewBox: t, children: /* @__PURE__ */ A("path", { d: "M2 2c-.563 0-1 .469-1 1v7.313l2.094-2.126a1.304 1.304 0 0 1 1.781 0L7 10.313l4.094-4.126a1.304 1.304 0 0 1 1.781 0L15 8.313V3c0-.531-.469-1-1-1H2zm-1 9.719V13c0 .563.438 1 1 1h1.281l3-3-2.125-2.094a.245.245 0 0 0-.343 0L1 11.72zm11.156-4.813a.245.245 0 0 0-.344 0L4.689 14H14c.531 0 1-.438 1-1V9.719l-2.844-2.813zM0 3c0-1.094.875-2 2-2h12c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H2c-1.125 0-2-.875-2-2V3zm5 1.5c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5 0 .281.219.5.5.5.25 0 .5-.219.5-.5zm-2 0c0-.531.281-1 .75-1.281.438-.281 1.031-.281 1.5 0 .438.281.75.75.75 1.281 0 .563-.313 1.031-.75 1.313-.469.28-1.063.28-1.5 0A1.496 1.496 0 0 1 3 4.5z" }) });
}
function ec(e) {
  const t = e.viewBox || "0 0 135 140";
  return /* @__PURE__ */ Z("svg", { preserveAspectRatio: "xMidYMid meet", fill: "#ccc", ...e, viewBox: t, children: [
    /* @__PURE__ */ Z("rect", { width: "15", height: "120", y: "10", rx: "6", children: [
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "height",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "y",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ Z("rect", { width: "15", height: "120", x: "30", y: "10", rx: "6", children: [
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "height",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "y",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ Z("rect", { width: "15", height: "140", x: "60", rx: "6", children: [
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "height",
          begin: "0s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "y",
          begin: "0s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ Z("rect", { width: "15", height: "120", x: "90", y: "10", rx: "6", children: [
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "height",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "y",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ Z("rect", { width: "15", height: "120", x: "120", y: "10", rx: "6", children: [
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "height",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ A(
        "animate",
        {
          attributeName: "y",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] })
  ] });
}
const Jn = "40%";
function tc(e) {
  const [t, n] = xe({
    isError: !1,
    loadingState: "initial"
    /* INITIAL */
  }), r = Ie(null), s = t.loadingState === "finished" && t.isError, i = e[o.TEST_ID], a = q({ "aria-description": e[o.ARIA_DESCRIPTION] }), l = h(i), c = h(i, "loader"), E = h(i, "placeholder"), d = h(i, "image"), N = h(i, "error"), S = e[F.IMAGE_SHAPE] === nt.ROUND, O = e[F.BORDER] || s, D = S ? "50%" : e[ut.BORDER_RADIUS], p = e[dt.BORDER_COLOR], $ = e[ut.BORDER_WIDTH], m = O ? $ : "0", y = e[F.FIT_MODE] === rt.FILL ? "cover" : "scale-down", U = _(e[ze.IMAGE_URL]) || void 0;
  let H = "auto", B = "100%";
  const ee = e[dt.IMAGE_SIZE], ce = ee === _e.AUTO;
  ce || ([B, H] = Qs(ee));
  const be = nc(B, H), Yt = t.loadingState === "initial" || s && !e[ze.DISPLAY_ERROR] ? /* @__PURE__ */ A(ac, { "data-testid": E, $iconColor: p, $size: be }) : null, Ht = t.loadingState === "loading" ? /* @__PURE__ */ A(
    ic,
    {
      "aria-description": "The image is being loaded",
      "data-testid": c,
      $iconColor: p,
      $size: be
    }
  ) : null, kt = t.isError && e[ze.DISPLAY_ERROR] ? /* @__PURE__ */ A(
    sc,
    {
      "aria-description": "Error while loading the image",
      "data-testid": N,
      $iconColor: p,
      $size: be
    }
  ) : null;
  return st(() => {
    r.current && U && (t.loadingState === "initial" || r.current.src !== U) && (r.current.src = U, n({ loadingState: "loading", isError: !1 }));
  }, [U, t.loadingState]), /* @__PURE__ */ Z(
    rc,
    {
      ...a,
      id: e[o.ELEMENT_ID],
      className: e[o.CLASS_NAME],
      "data-state": t.loadingState,
      "data-testid": l,
      $aspect: S ? "1/1" : "auto",
      $borderColor: p,
      $borderRadius: D,
      $borderStyle: s ? "dashed" : "solid",
      $borderWidth: m,
      $height: S && !ce ? B : H,
      $width: B,
      children: [
        Yt,
        Ht,
        /* @__PURE__ */ A(
          oc,
          {
            "data-testid": d,
            referrerPolicy: "no-referrer",
            ref: r,
            $aspect: S ? "1/1" : "auto",
            $fitMode: y,
            $height: S && !ce ? B : H,
            $width: B,
            $visible: t.loadingState === "finished" && !t.isError,
            onLoad: () => {
              n({ loadingState: "finished", isError: !1 }), e.onFinished && setTimeout(e.onFinished, 0);
            },
            onError: () => {
              n({ loadingState: "finished", isError: !0 }), e.onFinished && setTimeout(e.onFinished, 0);
            }
          }
        ),
        kt
      ]
    }
  );
}
function nc(e, t) {
  if (e.includes("%") || t.includes("%"))
    return Jn;
  const n = e.match(/([0-9]+)/), r = t.match(/([0-9]+)/);
  if (!(n != null && n.length) || !(r != null && r.length))
    return Jn;
  const s = Math.min(Number.parseInt(n[0]), Number.parseInt(r[0])), i = 32, a = 120, l = 80, c = 40, E = (c - l) / (a - i);
  return `${s >= a ? c : l + E * (s - i)}%`;
}
const rc = f(P)`
  align-content: center;
  align-items: center;
  aspect-ratio: ${(e) => e.$aspect};
  border-color: ${(e) => e.$borderColor || "transparent"};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-style: ${(e) => e.$borderStyle || "solid"};
  border-width: ${(e) => e.$borderWidth || "0"};
  display: flex;
  height: ${(e) => e.$height};
  justify-content: center;
  justify-items: center;
  max-width: ${(e) => e.$width};
  overflow: hidden;
  position: relative;
  width: ${(e) => e.$width};
`, oc = f.img`
  align-self: center;
  aspect-ratio: ${(e) => e.$aspect};
  display: ${(e) => e.$visible ? "flex" : "none"};
  height: ${(e) => e.$height};
  margin: 0 auto;
  object-fit: ${(e) => e.$fitMode || "scale-down"};
  width: ${(e) => e.$width};
`, sc = f(Ja)`
  display: flex;
  align-self: center;
  height: ${(e) => e.$size};
  margin: 0 auto;
  path {
    fill: ${(e) => e.$iconColor};
  }
  width: ${(e) => e.$size};
`, ic = f(ec)`
  display: flex;
  align-self: center;
  fill: ${(e) => e.$iconColor};
  height: ${(e) => e.$size};
  margin: 0 auto;
  width: calc(${(e) => e.$size} - 10%);
`, ac = f(Qa)`
  display: flex;
  align-self: center;
  height: ${(e) => e.$size};
  margin: 0 auto;
  path {
    fill: ${(e) => e.$iconColor};
  }
  width: ${(e) => e.$size};
`, an = new M({
  [dt.BORDER_COLOR]: { style: v.BORDER, styleType: u.COLOR },
  [dt.IMAGE_SIZE]: { style: _e.AUTO, styleType: u.IMAGE_SIZE }
}), ft = new M({
  [ut.BORDER_RADIUS]: {
    style: re.SMALL,
    styleType: u.BORDER_RADIUS
  },
  [ut.BORDER_WIDTH]: {
    style: oe.THIN,
    styleType: u.STROKE_WIDTH
  }
}), Pn = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], cc = [
  F.BORDER,
  F.DEFAULT_URL,
  F.IMAGE_SHAPE,
  F.FIT_MODE
], Zr = an.styleAttributeNames, jr = ft.styleAttributeNames, lc = [
  ...Pn,
  ...cc,
  ...Zr,
  ...jr
], Ec = [...Pn, F.DEFAULT_URL];
function qr(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r } = e, s = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return s ? r.evaluateCondition(s, n) : !0;
}
function dc(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r, hostAppConfig: s, options: i } = e;
  if (!qr(e))
    return null;
  const a = { ...t, ...ft.styleValues }, l = W(a, Ec), c = K(I.IMAGE, l, s), E = k(lc, c, {
    ...an.styleValues,
    ...ft.styleValues
  }), d = {
    ...an.styleTypes,
    ...ft.styleTypes
  }, N = z(E, d, s), S = { ...E, ...N }, O = uc(S), D = O[F.DEFAULT_URL] && r.interpolateString(O[F.DEFAULT_URL], n), p = O[o.DATA_SOURCE] && C(n, O[o.DATA_SOURCE], ""), $ = _(String(p || "")) || _(D), m = {
    ...ir(O, [o.DATA_SOURCE, F.DEFAULT_URL]),
    [ze.IMAGE_URL]: $,
    [ze.DISPLAY_ERROR]: !!(i != null && i.debugMode)
  };
  return /* @__PURE__ */ A(tc, { ...m });
}
function uc(e) {
  const t = b(e, Pn), n = b(e, Zr), r = b(e, jr);
  return {
    ...t,
    ...n,
    ...r,
    [F.BORDER]: Ge(e, F.BORDER),
    [F.FIT_MODE]: Q(
      e,
      F.FIT_MODE,
      [rt.FIT, rt.FILL],
      rt.FIT
    ),
    [F.IMAGE_SHAPE]: Q(
      e,
      F.IMAGE_SHAPE,
      [nt.ROUND, nt.RECT],
      nt.RECT
    ),
    [F.DEFAULT_URL]: R(e, F.DEFAULT_URL)
  };
}
var ne = /* @__PURE__ */ ((e) => (e.BORDER = "border", e.EXPANDABLE = "expandable", e.TITLE = "title", e))(ne || {}), Y = /* @__PURE__ */ ((e) => (e.BACKGROUND = "background", e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e.PADDING = "padding", e.TITLE_FONT_SIZE = "titleFontSize", e))(Y || {}), j = /* @__PURE__ */ ((e) => (e.BORDER_WIDTH = "borderWidth", e.TITLE_COLOR = "titleColor", e.TITLE_FONT_WEIGHT = "titleFontWeight", e.TITLE_SPACING = "titleSpacing", e))(j || {});
const cn = new M({
  [Y.BACKGROUND]: { style: L.TRANSPARENT, styleType: u.COLOR },
  [Y.BORDER_COLOR]: { style: v.BORDER, styleType: u.COLOR },
  [Y.BORDER_RADIUS]: { style: re.SMALL, styleType: u.BORDER_RADIUS },
  [Y.PADDING]: { style: G.MEDIUM, styleType: u.SPACING },
  [Y.TITLE_FONT_SIZE]: { style: le.DEFAULT, styleType: u.FONT_SIZE }
}), ln = new M({
  [j.BORDER_WIDTH]: { style: oe.THIN, styleType: u.STROKE_WIDTH },
  [j.TITLE_COLOR]: { style: v.DEFAULT_TEXT, styleType: u.COLOR },
  [j.TITLE_FONT_WEIGHT]: {
    style: Ee.SEMI_BOLD,
    styleType: u.FONT_WEIGHT
  },
  [j.TITLE_SPACING]: { style: G.SMALL, styleType: u.SPACING }
}), Jr = 6;
function Tc(e) {
  const [t, n] = xe(!1), r = Ie(null), [s, i] = Ke(e[Y.TITLE_FONT_SIZE]), a = e[o.TEST_ID], l = q({ "aria-description": e[o.ARIA_DESCRIPTION] }), c = h(a), E = h(a, "content"), d = h(a, "header"), N = h(a, "icon"), S = s, O = `calc(${s} * 0.75)`, D = (e[Y.PADDING] || "0").startsWith("0") ? `${Jr}px` : "0", p = () => {
    n((y) => !y);
  }, $ = Xr(t, r, 200, e.onAnimationEnd), m = Nn({
    to: {
      transform: t ? "rotate(-90deg)" : "rotate(0deg)"
    },
    config: {
      clamp: !0,
      friction: 20,
      tension: 200
    }
  });
  return /* @__PURE__ */ Z(
    Oc,
    {
      ...l,
      id: e[o.ELEMENT_ID],
      className: e[o.CLASS_NAME],
      "data-expandable": !0,
      "data-testid": c,
      $background: e[Y.BACKGROUND] || "transparent",
      $borderColor: e[Y.BORDER_COLOR] || "transparent",
      $borderRadius: e[Y.BORDER_RADIUS] || "0",
      $borderWidth: e[j.BORDER_WIDTH] || "0",
      $padding: e[Y.PADDING] || "0",
      $verticalMargin: D,
      children: [
        /* @__PURE__ */ Z(Lc, { onClick: p, children: [
          /* @__PURE__ */ A(
            _c,
            {
              "data-testid": d,
              $color: e[j.TITLE_COLOR],
              $fontSize: s,
              $fontWeight: e[j.TITLE_FONT_WEIGHT],
              $iconMargin: S,
              $iconSize: O,
              $lineHeight: i,
              children: _(e[ne.TITLE])
            }
          ),
          /* @__PURE__ */ A(Nc, { $width: s }),
          /* @__PURE__ */ A(
            Ac,
            {
              "data-testid": N,
              $size: O,
              $fillColor: e[j.TITLE_COLOR],
              style: m,
              children: /* @__PURE__ */ A(Wr, {})
            }
          )
        ] }),
        /* @__PURE__ */ A(Rc, { "data-testid": E, style: $, children: /* @__PURE__ */ A("div", { ref: r, children: /* @__PURE__ */ A(Ic, { $headerMargin: e[j.TITLE_SPACING], children: e.children }) }) })
      ]
    }
  );
}
const Ac = f(vt.div)`
  display: flex;
  fill: ${(e) => e.$fillColor};
  height: ${(e) => e.$size};
  min-width: ${(e) => e.$size};
  position: relative;
  width: ${(e) => e.$size};
`, Ic = f(P)`
  margin-top: ${(e) => e.$headerMargin};
`, Rc = f(vt.div)`
  overflow: hidden;
`, Nc = f(P)`
  display: flex;
  width: ${(e) => e.$width};
`, _c = f(P)`
  color: ${(e) => e.$color};
  flex-basis: calc(100% - calc(${(e) => e.$iconSize} + ${(e) => e.$iconMargin}));
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, Lc = f(P)`
  align-items: center;
  cursor: pointer;
  display: flex;
  position: relative;
`, Oc = f(P)`
  background: ${(e) => e.$background};
  border-color: ${(e) => e.$borderColor};
  border-radius: ${(e) => e.$borderRadius};
  border-style: solid;
  border-width: ${(e) => e.$borderWidth};
  margin: ${(e) => e.$verticalMargin} 0;
  padding: ${(e) => e.$padding};
`;
function Sc(e) {
  const [t, n] = Ke(e[Y.TITLE_FONT_SIZE]), r = e[o.TEST_ID], s = q({ "aria-description": e[o.ARIA_DESCRIPTION] }), i = h(r), a = h(r, "header"), l = h(r, "content"), c = (e[Y.PADDING] || "0").startsWith("0") ? `${Jr}px` : "0", E = _(e[ne.TITLE]), d = E ? /* @__PURE__ */ A(
    Dc,
    {
      className: e[o.CLASS_NAME],
      "data-testid": a,
      $color: e[j.TITLE_COLOR],
      $fontSize: t,
      $fontWeight: e[j.TITLE_FONT_WEIGHT],
      $lineHeight: n,
      $marginBottom: e[j.TITLE_SPACING],
      children: E
    }
  ) : null;
  return /* @__PURE__ */ Z(
    fc,
    {
      ...s,
      id: e[o.ELEMENT_ID],
      className: e[o.CLASS_NAME],
      "data-static": !0,
      "data-testid": i,
      $background: e[Y.BACKGROUND] || "transparent",
      $borderColor: e[Y.BORDER_COLOR] || "transparent",
      $borderRadius: e[Y.BORDER_RADIUS] || "0",
      $borderWidth: e[j.BORDER_WIDTH] || "0",
      $padding: e[Y.PADDING] || "0",
      $verticalMargin: c,
      children: [
        d,
        /* @__PURE__ */ A("div", { "data-testid": l, children: e.children })
      ]
    }
  );
}
const Dc = f(P)`
  color: ${(e) => e.$color};
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight};
  margin-bottom: ${(e) => e.$marginBottom};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, fc = f(P)`
  background: ${(e) => e.$background};
  border-color: ${(e) => e.$borderColor};
  border-radius: ${(e) => e.$borderRadius};
  border-style: solid;
  border-width: ${(e) => e.$borderWidth};
  margin: ${(e) => e.$verticalMargin} 0;
  padding: ${(e) => e.$padding};
`, vn = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], Cc = [ne.BORDER, ne.EXPANDABLE, ne.TITLE], pc = [...vn, ne.TITLE], Qr = cn.styleAttributeNames, eo = ln.styleAttributeNames, mc = [
  ...vn,
  ...Cc,
  ...Qr,
  ...eo
];
function to(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: s, getNodeDescriptor: i } = e, a = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return (a ? s.evaluateCondition(a, r) : !0) ? me({
    parentNodeName: I.SECTION,
    nodes: n,
    dataContext: r,
    getNodeDescriptor: i,
    expressionEvaluator: s
  }) : !1;
}
function hc(e) {
  const {
    actionCallbacks: t,
    attributes: n,
    children: r,
    dataContext: s,
    hostAppConfig: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    expressionEvaluator: c
  } = e;
  if (!to(e))
    return null;
  const E = { ...n, ...ln.styleValues }, d = W(E, pc), N = K(I.SECTION, d, i), S = k(
    mc,
    N,
    cn.styleValues
  ), O = { ...cn.styleTypes, ...ln.styleTypes }, D = z(S, O, i), p = { ...S, ...D }, $ = ye({
    parentNodeName: I.SECTION,
    nodes: r,
    dataContext: s,
    hostAppConfig: i,
    getInputRegistry: a,
    getNodeDescriptor: l,
    expressionEvaluator: c,
    actionCallbacks: t
  });
  if (!$.length)
    return null;
  const m = gc(p, s, c), U = m[ne.EXPANDABLE] ? Tc : Sc;
  return /* @__PURE__ */ A(U, { ...m, children: $ });
}
function gc(e, t, n) {
  const r = _(e[ne.TITLE]), s = r && _(n.interpolateString(r, t)), i = Ge(e, ne.EXPANDABLE), a = !!s && i && pn(), l = Ge(e, ne.BORDER), c = b(e, vn), E = b(e, [
    ...Qr,
    ...eo
  ]), d = {
    ...c,
    ...E,
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [ne.TITLE]: s,
    [ne.EXPANDABLE]: a
  };
  return l || (d[j.BORDER_WIDTH] = "0"), d;
}
var Fe = /* @__PURE__ */ ((e) => (e.SIZE = "size", e))(Fe || {});
const En = new M({
  [Fe.SIZE]: { style: G.SMALL, styleType: u.SPACING }
}), Mn = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], yc = [...Mn, ...En.styleAttributeNames];
function no(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r } = e, s = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return s ? r.evaluateCondition(s, n) : !0;
}
function $c(e) {
  const { attributes: t, hostAppConfig: n } = e;
  if (!no(e))
    return null;
  const r = W(t, Mn), s = K(I.SPACER, r, n), i = k(
    yc,
    s,
    En.styleValues
  ), a = z(i, En.styleTypes, n), l = { ...i, ...a }, c = bc(l), E = q({ "aria-description": c[o.ARIA_DESCRIPTION] }), d = h(c[o.TEST_ID]);
  return /* @__PURE__ */ A(
    Pc,
    {
      ...E,
      id: c[o.ELEMENT_ID],
      className: c[o.CLASS_NAME],
      "data-testid": d,
      $size: c[Fe.SIZE]
    }
  );
}
function bc(e) {
  return {
    ...b(e, Mn),
    [Fe.SIZE]: R(e, Fe.SIZE)
  };
}
const Pc = f(P)`
  max-height: ${(e) => e.$size};
  min-height: ${(e) => e.$size};
  width: 100%;
`, Wt = new M($e.styles), Rt = new M($e.styles);
Rt.overrideStyles({
  [w.VALUE_BACKGROUND]: { style: L.GREY_100, styleType: u.COLOR }
});
const Ct = new M({
  [ve.EXPAND_BUTTON_COLOR]: {
    style: v.PRIMARY,
    styleType: u.COLOR
  },
  [ve.EXPAND_BUTTON_FONT_SIZE]: {
    style: le.DEFAULT,
    styleType: u.FONT_SIZE
  },
  [ve.EXPAND_BUTTON_FONT_WEIGHT]: {
    style: Ee.MEDIUM,
    styleType: u.FONT_WEIGHT
  },
  [ve.EXPAND_BUTTON_DECORATION]: {
    style: Re.NONE,
    styleType: u.TEXT_DECORATION
  },
  [ve.EXPAND_BUTTON_HOVER_COLOR]: {
    style: v.PRIMARY,
    styleType: u.COLOR
  },
  [ve.EXPAND_BUTTON_HOVER_DECORATION]: {
    style: Re.UNDERLINED,
    styleType: u.TEXT_DECORATION
  }
}), ro = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.TEXT_DIRECTION,
  o.TEST_ID,
  o.ELEMENT_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.DISPLAY_STYLE,
  T.LABEL,
  T.MAX_LINES,
  T.MULTILINE_STYLE
], vc = [...ro, ...Wt.styleAttributeNames], Mc = [...ro, ...Rt.styleAttributeNames], Uc = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.LABEL
], oo = {
  ...Wt.styleValues,
  [o.TEXT_DIRECTION]: ae.AUTO,
  [T.DISPLAY_STYLE]: g.ROW,
  [T.MAX_LINES]: "1"
}, so = {
  ...oo,
  ...Rt.styleValues,
  [T.DISPLAY_STYLE]: g.STACKED,
  [T.MAX_LINES]: String(On),
  [T.MULTILINE_STYLE]: Ae.STATIC
}, xc = {
  ...so,
  [T.MAX_LINES]: "3"
};
function io(e) {
  const t = (n) => de(n) && !!_(n) || je(n) && An(n);
  return qe(I.STRING_VALUE, e, [o.DATA_SOURCE], t);
}
function Gc(e) {
  const { attributes: t, dataContext: n, hostAppConfig: r } = e;
  if (!io(e))
    return null;
  const s = { ...t, ...Ct.styleValues }, i = W(s, Uc), a = K(I.STRING_VALUE, i, r), l = Math.max(At(a, T.MAX_LINES, 1), 1) > 1, c = R(a, T.MULTILINE_STYLE), E = l && c === Ae.EXPANDABLE, d = l ? E ? xc : so : oo, N = l ? [...Mc, ...Ct.styleAttributeNames] : vc, S = k(N, a, d), O = l ? { ...Rt.styleTypes, ...Ct.styleTypes } : Wt.styleTypes, D = z(S, O, r), p = { ...S, ...D }, $ = R(p, o.DATA_SOURCE), m = wc(p), y = String(C(n, $, "")).trim();
  return /* @__PURE__ */ A(Ve, { ...m, value: y });
}
function wc(e) {
  const t = Math.max(1, At(e, T.MAX_LINES)), n = t > 1, r = n ? g.STACKED : g.ROW, s = n ? [
    ...Rt.styleAttributeNames,
    ...Ct.styleAttributeNames
  ] : Wt.styleAttributeNames, i = b(e, s);
  return {
    // Functional props
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [T.DISPLAY_STYLE]: Q(
      e,
      T.DISPLAY_STYLE,
      [g.STACKED, g.ROW],
      r
    ),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [T.LABEL]: R(e, T.LABEL),
    [T.LINKIFY_VALUE_FLAG]: !1,
    [T.MAX_LINES]: Math.min(t, On),
    [T.MULTILINE_STYLE]: Q(
      e,
      T.MULTILINE_STYLE,
      [Ae.SCROLLABLE, Ae.STATIC, Ae.EXPANDABLE],
      Ae.STATIC
    ),
    [o.TEST_ID]: R(e, o.TEST_ID),
    // Styling props
    ...i
  };
}
const Nt = new M($e.styles);
Nt.overrideStyles({
  [w.VALUE_COLOR]: { style: v.PRIMARY, styleType: u.COLOR },
  [w.LINK_DECORATION]: {
    style: Re.NONE,
    styleType: u.TEXT_DECORATION
  },
  [w.LINK_HOVER_COLOR]: {
    style: v.PRIMARY,
    styleType: u.COLOR
  },
  [w.LINK_HOVER_DECORATION]: {
    style: Re.UNDERLINED,
    styleType: u.TEXT_DECORATION
  }
});
const ao = new _s();
ao.tlds(Ls).add("mailto:", null).add("ftp:", null);
function co(e) {
  const t = e.trim();
  if (!t)
    return "";
  const n = ao.match(t);
  return n && n[0].url || t;
}
function Bc(e) {
  const t = co(e);
  if (!t)
    return "";
  const n = new URL(t), r = n.pathname === "/" ? "" : n.pathname;
  return `${n.hostname}${r}`;
}
const Fc = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.TEXT_DIRECTION,
  o.TEST_ID,
  o.ELEMENT_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.DISPLAY_STYLE,
  T.LABEL,
  T.LINK_URL,
  we.LINK_TEXT,
  we.OPEN_IN_PLACE
], Vc = [...Fc, ...Nt.styleAttributeNames], Wc = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.LABEL,
  T.LINK_URL,
  we.LINK_TEXT
], Xc = {
  ...Nt.styleValues,
  [o.TEXT_DIRECTION]: ae.AUTO,
  [T.DISPLAY_STYLE]: g.ROW,
  [we.OPEN_IN_PLACE]: "false"
};
function lo(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r } = e, s = _(R(t, T.LINK_URL)), i = s && _(r.interpolateString(s, n)), a = (l) => {
    if (!cs(l) && !Er(l))
      throw Error(`Inable to render <${I.LINK}>: invalid "${o.DATA_SOURCE}" attribute value`);
    return !!(l || i);
  };
  return qe(I.LINK, e, [], a);
}
function Yc(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r, hostAppConfig: s } = e;
  if (!lo(e))
    return null;
  const i = W(t, Wc), a = K(I.LINK, i, s), l = k(Vc, a, Xc), c = z(l, Nt.styleTypes, s), E = { ...l, ...c }, d = _(R(E, we.LINK_TEXT)), N = _(r.interpolateString(d, n)), S = Hc(E, n, r), O = Bc(S[T.LINK_URL]);
  return /* @__PURE__ */ A(Ve, { ...S, value: N || O });
}
function Hc(e, t, n) {
  const r = Ge(e, we.OPEN_IN_PLACE, !1), s = _(R(e, T.LINK_URL)), i = s && _(n.interpolateString(s, t)), a = _(R(e, o.DATA_SOURCE)), l = String(C(t, a)), c = b(e, Nt.styleAttributeNames);
  return {
    // Functional props
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [T.DISPLAY_STYLE]: Q(
      e,
      T.DISPLAY_STYLE,
      [g.STACKED, g.ROW],
      g.ROW
    ),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [T.LABEL]: R(e, T.LABEL),
    [T.MAX_LINES]: 1,
    [o.TEST_ID]: R(e, o.TEST_ID),
    [T.LINKIFY_VALUE_FLAG]: !0,
    [T.LINK_URL]: co(i || l),
    [T.LINK_TARGET]: r ? void 0 : "_blank",
    // Styling props
    ...c
  };
}
function Eo(e, t, n, r) {
  const { __root: s, __scope: i } = e, a = [i || "", r, String(n)].filter((c) => !!c);
  let l = {
    __root: s,
    __parent: ir(e, "__root"),
    __scope: a.join("."),
    __index: n,
    __data: t
  };
  return _n(t) && (l = { ...t, ...l }), Object.freeze(l);
}
const uo = ({
  attributes: e,
  children: t,
  parentNodeName: n,
  dataContext: r,
  getNodeDescriptor: s,
  expressionEvaluator: i
}) => {
  const a = _(C(e, o.DATA_SOURCE));
  if (!a)
    throw Error(`<List> is missing "${o.DATA_SOURCE}" parameter`);
  const l = C(r, a);
  if (mt(l) || !Tn(l) || mt(t))
    return !1;
  const c = _(C(e, o.CONDITIONAL_RENDERING_EXPRESSION));
  if (!(c ? i.evaluateCondition(c, r) : !0))
    return !1;
  const d = C(e, o.INTERNAL_COMPONENT_ID);
  return !!ls(l, (N, S) => {
    const O = Eo(r, N, S, d);
    return me({
      parentNodeName: n,
      nodes: t,
      dataContext: O,
      getNodeDescriptor: s,
      expressionEvaluator: i
    });
  });
};
var dn = /* @__PURE__ */ ((e) => (e.ITEM_SPACING = "itemSpacing", e.SEPARATE_LIST_ITEMS = "separateItems", e))(dn || {});
const Qn = G.SMALL, er = !1, kc = (e) => {
  const {
    actionCallbacks: t,
    attributes: n,
    children: r,
    parentNodeName: s,
    dataContext: i,
    hostAppConfig: a,
    getInputRegistry: l,
    getNodeDescriptor: c,
    expressionEvaluator: E
  } = e;
  if (!r || !uo(e))
    return null;
  let d = er, N = Qn;
  try {
    d = Ge(
      n,
      dn.SEPARATE_LIST_ITEMS,
      er
    ), N = R(n, dn.ITEM_SPACING, Qn);
  } catch (U) {
    throw Error(`Unable to render <List>. ${U.message}`);
  }
  const S = C(n, o.INTERNAL_COMPONENT_ID), O = _(C(n, o.DATA_SOURCE)), D = C(i, O), p = C(n, o.TEST_ID), $ = h(p, "list-item"), m = d ? Kc(N, a, l, c, p) : zc(N, a, l, c, p), y = D.reduce(
    (U, H, B) => {
      const ee = Eo(i, H, B, S);
      if (!me({
        parentNodeName: s,
        nodes: r,
        dataContext: ee,
        getNodeDescriptor: c,
        expressionEvaluator: E
      }))
        return U;
      const ce = ye({
        parentNodeName: s,
        nodes: r,
        dataContext: ee,
        hostAppConfig: a,
        getInputRegistry: l,
        getNodeDescriptor: c,
        expressionEvaluator: E,
        actionCallbacks: t
      });
      return U.push(ce), U;
    },
    []
  );
  return y.reduce((U, H, B) => (B < y.length - 1 && m && H.push(/* @__PURE__ */ A(Rn, { children: m }, `separator-${B}`)), U.push(
    /* @__PURE__ */ A(Zc, { "data-testid": $, children: H }, `item-${B}`)
  ), U), []);
};
function Kc(e, t, n, r, s) {
  const i = r(I.DIVIDER), a = { __root: {}, __data: "" }, l = {
    interpolateString: () => "",
    evaluateCondition: () => !0
  }, c = {
    onAction: () => {
    },
    onActionError: () => {
    }
  }, E = W({ [Ne.SPACING]: e });
  [G.NONE, G.X_SMALL].includes(E[Ne.SPACING]) && delete E[Ne.SPACING];
  const d = h(s, "divider");
  return d && (E[o.TEST_ID] = d), i.render({
    attributes: E,
    dataContext: a,
    hostAppConfig: t,
    getInputRegistry: n,
    getNodeDescriptor: r,
    expressionEvaluator: l,
    actionCallbacks: c
  });
}
function zc(e, t, n, r, s) {
  const i = r(I.SPACER), a = { __root: {}, __data: "" }, l = {
    interpolateString: () => "",
    evaluateCondition: () => !0
  }, c = {
    onAction: () => {
    },
    onActionError: () => {
    }
  }, E = W({
    [Fe.SIZE]: e
  });
  if (E[Fe.SIZE] === G.NONE)
    return null;
  const d = h(s, "spacer");
  return d && (E[o.TEST_ID] = d), i.render({
    attributes: E,
    dataContext: a,
    hostAppConfig: t,
    getInputRegistry: n,
    getNodeDescriptor: r,
    expressionEvaluator: l,
    actionCallbacks: c
  });
}
const Zc = f.div`
  width: 100%;
`, Xt = new M($e.styles), To = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.DATA_SOURCE,
  o.ELEMENT_ID,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION,
  T.LABEL,
  ue.DECIMAL_PLACES,
  ue.LOCALE
], jc = [
  ...To,
  o.TEXT_DIRECTION,
  T.DISPLAY_STYLE
], qc = [...jc, ...Xt.styleAttributeNames], Jc = {
  ...Xt.styleValues,
  [o.TEXT_DIRECTION]: ae.AUTO,
  [T.DISPLAY_STYLE]: g.ROW,
  [ue.DECIMAL_PLACES]: "2"
};
function Ao(e) {
  const t = (n) => de(n) && !!_(n) || je(n) && isFinite(n);
  return qe(I.NUMERIC_VALUE, e, [o.DATA_SOURCE], t);
}
function Qc(e) {
  const { attributes: t, dataContext: n, hostAppConfig: r } = e;
  if (!Ao(e))
    return null;
  const s = W(t, To), i = K(I.NUMERIC_VALUE, s, r), a = k(qc, i, Jc), l = z(a, Xt.styleTypes, r), c = { ...a, ...l }, E = tl(c), d = el(c, n);
  return /* @__PURE__ */ A(Ve, { ...E, value: d });
}
function el(e, t) {
  const n = R(e, o.DATA_SOURCE), r = C(t, n), s = Number(r);
  if (Number.isNaN(s))
    throw Error(`Unable to render <${I.NUMERIC_VALUE}>. Invalid value: "${r}"`);
  const i = Math.max(At(e, ue.DECIMAL_PLACES), 0), a = R(e, ue.LOCALE) || navigator.language;
  try {
    return Intl.NumberFormat(a, {
      minimumFractionDigits: i,
      maximumFractionDigits: i
    }).format(s);
  } catch {
    throw Error(`Invalid locale: "${a}"`);
  }
}
function tl(e) {
  const t = b(e, Xt.styleAttributeNames);
  return {
    // Functional props
    [o.ARIA_DESCRIPTION]: R(e, o.ARIA_DESCRIPTION),
    [o.CLASS_NAME]: R(e, o.CLASS_NAME),
    [o.ELEMENT_ID]: R(e, o.ELEMENT_ID),
    [o.TEST_ID]: R(e, o.TEST_ID),
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    [T.DISPLAY_STYLE]: Q(
      e,
      T.DISPLAY_STYLE,
      [g.STACKED, g.ROW],
      g.ROW
    ),
    [T.LABEL]: R(e, T.LABEL),
    [T.LINKIFY_VALUE_FLAG]: !1,
    [T.MAX_LINES]: 1,
    // Styling props
    ...t
  };
}
var Oe = /* @__PURE__ */ ((e) => (e[e.BOLD = 0] = "BOLD", e[e.ITALIC = 1] = "ITALIC", e[e.UNDERLINE = 2] = "UNDERLINE", e[e.STRIKETHROUGH = 3] = "STRIKETHROUGH", e[e.LINE_BREAK = 4] = "LINE_BREAK", e))(Oe || {});
const Io = Object.values(Oe), tr = {
  Bold: 0,
  Italic: 1,
  Strikethrough: 3,
  Underline: 2,
  Linebreak: 4,
  // short term backwards compatibility
  b: 0,
  br: 4,
  i: 1,
  s: 3,
  u: 2
  /* UNDERLINE */
};
function Ro(e) {
  const t = tr[e] ?? tr[e.toLowerCase()];
  if (t !== void 0)
    return t;
  throw Error(`Unexpected text block child "${e}"`);
}
function No(e, t, n) {
  return e.length ? e.reduce((r, s) => {
    if (Mt(s)) {
      const i = n.interpolateString(s.text, t);
      return r + _(i);
    } else if (De(s)) {
      const i = Ro(s.name);
      return Io.includes(i) && i !== Oe.LINE_BREAK ? r + _(No(s.children, t, n)) : r;
    } else
      throw Error(`Unexpected text block child "${s.type}"`);
  }, "") : "";
}
function _o(e, t, n) {
  return e.length ? e.map((s, i) => {
    if (Mt(s)) {
      const a = n.interpolateString(s.text, t);
      return /* @__PURE__ */ A(Rn, { children: a }, i);
    } else if (De(s)) {
      const a = Ro(s.name);
      if (!Io.includes(a))
        return null;
      let l;
      switch (a !== Oe.LINE_BREAK && (l = _o(s.children, t, n)), a) {
        case Oe.BOLD:
          return /* @__PURE__ */ A("b", { children: l }, i);
        case Oe.ITALIC:
          return /* @__PURE__ */ A("i", { children: l }, i);
        case Oe.LINE_BREAK:
          return /* @__PURE__ */ A("br", {}, i);
        case Oe.STRIKETHROUGH:
          return /* @__PURE__ */ A("s", { children: l }, i);
        case Oe.UNDERLINE:
          return /* @__PURE__ */ A("u", { children: l }, i);
        default:
          return null;
      }
    } else
      throw Error(`Unexpected text block child "${s.type}"`);
  }).filter((s) => !!s) : null;
}
var Ue = /* @__PURE__ */ ((e) => (e.MAX_LINES = "maxLines", e.LINE_HEIGHT = "lineHeight", e))(Ue || {}), V = /* @__PURE__ */ ((e) => (e.ALIGNMENT = "alignment", e.BACKGROUND = "background", e.COLOR = "color", e.FONT_SIZE = "fontSize", e.FONT_WEIGHT = "fontWeight", e.WRAP_MODE = "wrap", e))(V || {});
const un = new M({
  [V.ALIGNMENT]: { style: ie.LEFT, styleType: u.ALIGNMENT },
  [V.BACKGROUND]: { style: L.TRANSPARENT, styleType: u.COLOR },
  [V.COLOR]: { style: v.DEFAULT_TEXT, styleType: u.COLOR },
  [V.FONT_SIZE]: { style: le.DEFAULT, styleType: u.FONT_SIZE },
  [V.FONT_WEIGHT]: { style: Ee.REGULAR, styleType: u.FONT_WEIGHT },
  [V.WRAP_MODE]: { style: yt.NORMAL, styleType: u.TEXT_WRAPPING }
}), Lo = [
  o.ARIA_DESCRIPTION,
  o.CLASS_NAME,
  o.ELEMENT_ID,
  o.TEXT_DIRECTION,
  o.TEST_ID,
  o.CONDITIONAL_RENDERING_EXPRESSION
], nl = [Ue.MAX_LINES], Oo = un.styleAttributeNames, rl = [...Lo, ...nl, ...Oo];
function So(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: s } = e, i = R(t, o.CONDITIONAL_RENDERING_EXPRESSION);
  return (i ? s.evaluateCondition(i, r) : !0) ? !!No(n || [], r, s) : !1;
}
function ol(e) {
  const { attributes: t, children: n, dataContext: r, hostAppConfig: s, expressionEvaluator: i } = e;
  if (!So(e))
    return null;
  const a = W(t, Lo), l = K(I.TEXT, a, s), c = k(rl, l, un.styleValues), E = z(c, un.styleTypes, s), d = { ...c, ...E }, N = sl(d), S = N[o.ARIA_DESCRIPTION], O = N[o.TEST_ID], D = q({ "aria-description": S }), p = q({ "data-testid": O }), $ = N[Ue.MAX_LINES], m = /* @__PURE__ */ A(
    il,
    {
      ...D,
      ...p,
      id: N[o.ELEMENT_ID],
      className: N[o.CLASS_NAME],
      dir: N[o.TEXT_DIRECTION] || "auto",
      $alignment: N[V.ALIGNMENT],
      $background: N[V.BACKGROUND],
      $color: N[V.COLOR],
      $fontSize: N[V.FONT_SIZE],
      $fontWeight: N[V.FONT_WEIGHT],
      $lineHeight: N[Ue.LINE_HEIGHT],
      $wrap: N[V.WRAP_MODE],
      children: _o(n || [], r, i)
    }
  );
  return /* @__PURE__ */ A(ht, { clamp: $, useNativeClamp: !0, children: m });
}
function sl(e) {
  const t = At(e, Ue.MAX_LINES, Hn);
  if (t <= 0)
    throw Error(`Unexpected maxLines attribute value. Expected a positive number, got "${t}"`);
  const n = b(e, Oo), r = b(e, [
    o.ARIA_DESCRIPTION,
    o.CLASS_NAME,
    o.ELEMENT_ID,
    o.TEST_ID
  ]), [s, i] = Ke(
    n[V.FONT_SIZE]
  );
  return {
    ...r,
    [o.TEXT_DIRECTION]: pe(e, o.TEXT_DIRECTION),
    ...n,
    [V.ALIGNMENT]: _r(e, V.ALIGNMENT),
    [Ue.MAX_LINES]: Math.min(t, Hn),
    [V.FONT_SIZE]: s,
    [Ue.LINE_HEIGHT]: i,
    [V.WRAP_MODE]: R(e, V.WRAP_MODE)
  };
}
const il = f(P)`
  background: ${(e) => e.$background || "inherit"};
  color: ${(e) => e.$color};
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight || "normal"};
  text-align: ${(e) => e.$alignment || "inherit"};
  word-wrap: ${(e) => e.$wrap || "normal"};
`, nr = () => null, rr = {
  [I.BLOCK]: { canRender: Dr, nodeType: x.CONTAINER, render: pi },
  [I.BOOLEAN_VALUE]: {
    canRender: Cr,
    nodeType: x.DATA_VALUE,
    render: Ki
  },
  [I.CARD]: { canRender: mr, nodeType: x.CONTAINER, render: Ji },
  [I.COLUMN]: { canRender: br, nodeType: x.CONTAINER, render: la },
  [I.COLUMN_GROUP]: { canRender: gr, nodeType: x.CONTAINER, render: na },
  [I.CURRENCY_VALUE]: {
    canRender: vr,
    nodeType: x.DATA_VALUE,
    render: Ia
  },
  [I.DATETIME_VALUE]: {
    canRender: Ur,
    nodeType: x.DATA_VALUE,
    render: Da
  },
  [I.DIVIDER]: { canRender: wr, nodeType: x.DECORATIVE_NODE, render: ma },
  [I.DRAWER]: { canRender: Br, nodeType: x.CONTAINER, render: Xa },
  [I.DRAWER_FIXED_PART]: {
    canRender: Fr,
    nodeType: x.CONTAINER,
    render: nr
  },
  [I.DRAWER_EXPANDABLE_PART]: {
    canRender: $a,
    nodeType: x.CONTAINER,
    render: nr
  },
  [I.FORMULA]: {
    canRender: Kr,
    nodeType: x.DATA_VALUE,
    render: ja
  },
  [I.IMAGE]: { canRender: qr, nodeType: x.DATA_VALUE, render: dc },
  [I.LINK]: { canRender: lo, nodeType: x.DATA_VALUE, render: Yc },
  [I.LIST]: { canRender: uo, nodeType: x.ITERATOR, render: kc },
  [I.NUMERIC_VALUE]: {
    canRender: Ao,
    nodeType: x.DATA_VALUE,
    render: Qc
  },
  [I.SECTION]: { canRender: to, nodeType: x.CONTAINER, render: hc },
  [I.SPACER]: { canRender: no, nodeType: x.DECORATIVE_NODE, render: $c },
  [I.STRING_VALUE]: {
    canRender: io,
    nodeType: x.DATA_VALUE,
    render: Gc
  },
  [I.TEXT]: { canRender: So, nodeType: x.DATA_VALUE, render: ol }
}, qt = (e) => {
  const t = _(e);
  if (!rr[t])
    throw Error(`Unknown component "${e}"`);
  return rr[t];
};
class Do {
  /**
   * Optional parameter is primarily used for testing
   * @param registry - where to store the input control(s) data
   */
  constructor(t) {
    tt(this, "registry");
    this.registry = t || {};
  }
  registerControl(t, n) {
    const r = _(t);
    if (!r)
      throw Error("InputRegistry.register: missing or invalid id");
    const s = n.actions.map((a) => _(a)).filter((a) => !!a), i = _(n.scope);
    this.registry[r] = {
      actions: s,
      attributes: n.attributes,
      scope: i,
      getValue: n.getValue
    };
  }
  unregisterControl(t) {
    const n = _(t);
    if (!n)
      throw Error("InputRegistry.unregister: missing or invalid id");
    delete this.registry[n];
  }
  reset() {
    const t = Object.keys(this.registry);
    for (const n of t)
      this.unregisterControl(n);
  }
  findAllByAction(t, n) {
    const r = _(t), s = _(n);
    let i = Object.values(this.registry).filter((a) => a.actions.includes(r));
    return s && (i = i.filter((a) => !a.scope || a.scope.startsWith(s) || s.startsWith(a.scope))), i;
  }
}
function al(e) {
  const [t, n] = xe(), r = Ie(null);
  st(() => {
    r.current && !t && n(r.current);
  }, [t]);
  const s = t ? /* @__PURE__ */ A(Is, { target: t.shadowRoot, children: e.children }) : null;
  return /* @__PURE__ */ A(Os.div, { ref: r, children: s });
}
function fo({
  template: e,
  data: t,
  hostConfig: n,
  onAction: r,
  onActionError: s,
  options: i,
  stateStore: a
}) {
  const l = _(e);
  if (!l)
    throw Error("Invalid or missing template");
  const E = !!(i != null && i.preprocessTemplate) ? Qt(l) : l, N = Jt(E).root;
  ur(N, o.INTERNAL_COMPONENT_ID);
  const S = dr(t), O = qt(N.name), D = Nr();
  if (!O.canRender({
    attributes: N.attributes,
    children: N.children,
    dataContext: S,
    getNodeDescriptor: qt,
    expressionEvaluator: D
  }))
    return null;
  const $ = {
    onAction: r || (() => {
    }),
    onActionError: s || (() => {
    })
  }, m = () => {
    if (!a.inputRegistry)
      throw Error("Input registry is missing or invalid");
    return a.inputRegistry;
  };
  return O.render({
    actionCallbacks: $,
    attributes: N.attributes,
    children: N.children,
    dataContext: S,
    hostAppConfig: n,
    getInputRegistry: m,
    getNodeDescriptor: qt,
    expressionEvaluator: D,
    options: i
  });
}
const hl = lr(
  (e, t) => {
    var s;
    const n = Ie({
      inputRegistry: new Do()
    });
    st(() => {
      const i = n.current;
      return () => {
        var a;
        (a = i.inputRegistry) == null || a.reset();
      };
    });
    const r = fo({ ...e, stateStore: n.current });
    return (s = e.options) != null && s.useShadowDOM ? /* @__PURE__ */ A(al, { children: /* @__PURE__ */ A(or, { ref: t, children: r }) }) : /* @__PURE__ */ A(or, { ref: t, children: r });
  }
);
function gl({
  template: e,
  data: t,
  hostConfig: n,
  onAction: r,
  onActionError: s,
  options: i,
  stateStore: a
}) {
  const l = {
    debugMode: i == null ? void 0 : i.debugMode,
    preprocessTemplate: i == null ? void 0 : i.preprocessTemplate,
    returnUnwrappedNodes: !0,
    useShadowDOM: !1
  };
  return a.inputRegistry = a.inputRegistry || new Do(), a.inputRegistry.reset(), fo({ template: e, data: t, hostConfig: n, onAction: r, onActionError: s, options: l, stateStore: a });
}
const or = f.div`
  max-width: 100%;
  flex-basis: max-content;
  flex-grow: 1;
`;
export {
  ml as CardTemplateReader,
  hl as ReactCardRenderer,
  gl as renderTemplateNodes
};
//# sourceMappingURL=card-renderer.js.map
